import "./admin.af4f0403.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb963"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb963"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aZAsu = parcelRequire("aZAsu");
const $e92e63ec1fda26be$export$ead625510f6b71f5 = ({ photos: photos, avatarUrl: avatarUrl, onChangePhotos: onChangePhotos })=>{
    const [urlInput, setUrlInput] = (0, $acw62.useState)('');
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const [isProcessing, setIsProcessing] = (0, $acw62.useState)(false);
    const fileInputRef = (0, $acw62.useRef)(null);
    const dropZoneRef = (0, $acw62.useRef)(null);
    // Сжатие изображения через Canvas для оптимизации памяти и трафика
    const processImageFile = (file)=>{
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onload = (e)=>{
                const img = new Image();
                img.onload = ()=>{
                    const maxDimension = 1200;
                    let { width: width, height: height } = img;
                    if (width > maxDimension || height > maxDimension) {
                        if (width > height) {
                            height = Math.round(height * maxDimension / width);
                            width = maxDimension;
                        } else {
                            width = Math.round(width * maxDimension / height);
                            height = maxDimension;
                        }
                    }
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    if (!ctx) {
                        resolve(e.target?.result);
                        return;
                    }
                    ctx.drawImage(img, 0, 0, width, height);
                    const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.85);
                    resolve(compressedDataUrl);
                };
                img.onerror = ()=>resolve(e.target?.result);
                img.src = e.target?.result;
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    const addImages = async (newImages)=>{
        if (newImages.length === 0) return;
        const updated = [
            ...photos,
            ...newImages
        ];
        // Если аватарки еще нет, ставим первую загруженную
        const newAvatar = avatarUrl && photos.includes(avatarUrl) ? avatarUrl : updated[0] || '';
        onChangePhotos(updated, newAvatar);
    };
    const handleFiles = async (files)=>{
        if (!files || files.length === 0) return;
        setIsProcessing(true);
        try {
            const promises = [];
            for(let i = 0; i < files.length; i++){
                const file = files[i];
                if (file.type.startsWith('image/')) promises.push(processImageFile(file));
            }
            const base64List = await Promise.all(promises);
            await addImages(base64List);
        } catch (err) {
            console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u0444\u0430\u0439\u043B\u043E\u0432:", err);
        } finally{
            setIsProcessing(false);
        }
    };
    // Перетаскивание (Drag & Drop)
    const handleDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };
    const handleDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };
    const handleDrop = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        await handleFiles(e.dataTransfer.files);
    };
    // Вставка из буфера обмена (Paste / Ctrl+V / Cmd+V)
    (0, $acw62.useEffect)(()=>{
        const handlePaste = async (e)=>{
            const clipEvent = e;
            const items = clipEvent.clipboardData?.items;
            if (!items) return;
            const imageFiles = [];
            for(let i = 0; i < items.length; i++)if (items[i].type.startsWith('image/')) {
                const file = items[i].getAsFile();
                if (file) imageFiles.push(file);
            }
            if (imageFiles.length > 0) {
                setIsProcessing(true);
                try {
                    const promises = imageFiles.map((f)=>processImageFile(f));
                    const base64List = await Promise.all(promises);
                    await addImages(base64List);
                } catch (err) {
                    console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u0441\u0442\u0430\u0432\u043A\u0438 \u0438\u0437 \u0431\u0443\u0444\u0435\u0440\u0430:", err);
                } finally{
                    setIsProcessing(false);
                }
            }
        };
        window.addEventListener('paste', handlePaste);
        return ()=>window.removeEventListener('paste', handlePaste);
    }, [
        photos,
        avatarUrl
    ]);
    const handleAddUrl = (e)=>{
        e.preventDefault();
        if (!urlInput.trim()) return;
        addImages([
            urlInput.trim()
        ]);
        setUrlInput('');
    };
    const handleSetAvatar = (photoUrl)=>{
        onChangePhotos(photos, photoUrl);
    };
    const handleDeletePhoto = (indexToDelete)=>{
        const photoToDelete = photos[indexToDelete];
        const updated = photos.filter((_, i)=>i !== indexToDelete);
        let newAvatar = avatarUrl;
        if (avatarUrl === photoToDelete) newAvatar = updated[0] || '';
        onChangePhotos(updated, newAvatar);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "photo-gallery-manager",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: dropZoneRef,
                className: `photo-drop-zone ${isDragging ? 'dragging' : ''} ${isProcessing ? 'processing' : ''}`,
                onDragOver: handleDragOver,
                onDragLeave: handleDragLeave,
                onDrop: handleDrop,
                onClick: ()=>fileInputRef.current?.click(),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: fileInputRef,
                        type: "file",
                        multiple: true,
                        accept: "image/*",
                        style: {
                            display: 'none'
                        },
                        onChange: (e)=>handleFiles(e.target.files)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "drop-zone-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "drop-zone-icon-box",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconUpload), {
                                    size: 22
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "drop-zone-text",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        children: isProcessing ? "\u041E\u0411\u0420\u0410\u0411\u041E\u0422\u041A\u0410 \u0418\u0417\u041E\u0411\u0420\u0410\u0416\u0415\u041D\u0418\u0419..." : "\u041F\u0415\u0420\u0415\u0422\u0410\u0429\u0418\u0422\u0415 \u0424\u0410\u0419\u041B\u042B \u0418\u041B\u0418 \u041D\u0410\u0416\u041C\u0418\u0422\u0415 \u0414\u041B\u042F \u0412\u042B\u0411\u041E\u0420\u0410"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "drop-zone-sub",
                                        children: "\u041C\u0443\u043B\u044C\u0442\u0438\u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430, Drag & Drop \u0438 \u043F\u0440\u044F\u043C\u0430\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0430 \u0438\u0437 \u0431\u0443\u0444\u0435\u0440\u0430 (Ctrl+V / Cmd+V)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "url-add-row",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "url",
                        placeholder: "\u0412\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043F\u0440\u044F\u043C\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u0444\u043E\u0442\u043E (https://...)",
                        value: urlInput,
                        onChange: (e)=>setUrlInput(e.target.value),
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') handleAddUrl(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        className: "btn btn-secondary",
                        onClick: handleAddUrl,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconPlus), {
                                size: 13
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "\u0414\u041E\u0411\u0410\u0412\u0418\u0422\u042C URL"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "gallery-header-bar",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "gallery-count",
                        children: [
                            "\u0410\u041A\u0422\u0418\u0412\u041D\u042B\u0425 \u0424\u041E\u0422\u041E: ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: photos.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "gallery-hint",
                        children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043E\u0441\u043D\u043E\u0432\u043D\u044B\u043C \u0430\u0432\u0430\u0442\u0430\u0440\u043E\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
                    })
                ]
            }),
            photos.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "no-photos-alert",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconAlert), {
                        size: 14
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0435\u0449\u0435 \u043D\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u044B. \u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u0432\u044B\u0448\u0435 \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 Ctrl+V."
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "photos-grid",
                children: photos.map((photo, index)=>{
                    const isAvatar = photo === avatarUrl;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `photo-card ${isAvatar ? 'is-avatar' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "photo-thumb-wrap",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: photo,
                                        alt: `Photo ${index + 1}`
                                    }),
                                    isAvatar && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "avatar-tag-badge",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconStarFilled), {
                                                size: 10
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u041E\u0421\u041D\u041E\u0412\u041D\u041E\u0419 \u0410\u0412\u0410\u0422\u0410\u0420"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "photo-card-actions",
                                children: [
                                    !isAvatar ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        className: "btn-set-avatar",
                                        title: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0433\u043B\u0430\u0432\u043D\u044B\u043C \u0430\u0432\u0430\u0442\u0430\u0440\u043E\u043C \u0431\u043E\u0442\u0430",
                                        onClick: ()=>handleSetAvatar(photo),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconStar), {
                                                size: 12
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u041D\u0410\u0417\u041D\u0410\u0427\u0418\u0422\u042C"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "avatar-active-label",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                                size: 12
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u0410\u041A\u0422\u0418\u0412\u0415\u041D"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: "btn-delete-photo",
                                        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u043E\u0442\u043E",
                                        onClick: ()=>handleDeletePhoto(index),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconTrash), {
                                            size: 12
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aZAsu = parcelRequire("aZAsu");
const $fd1ae8e317ad1e5f$export$bf898595ac5d35d5 = ({ variables: variables, onChange: onChange })=>{
    const [newKey, setNewKey] = (0, $acw62.useState)('');
    const [newVal, setNewVal] = (0, $acw62.useState)('');
    const handleAdd = ()=>{
        const cleanKey = newKey.trim().replace(/[^a-zA-Z0-9_-]/g, '');
        if (!cleanKey) return;
        onChange({
            ...variables,
            [cleanKey]: newVal.trim()
        });
        setNewKey('');
        setNewVal('');
    };
    const handleRemove = (keyToRemove)=>{
        const next = {
            ...variables
        };
        delete next[keyToRemove];
        onChange(next);
    };
    const handleUpdate = (key, val)=>{
        onChange({
            ...variables,
            [key]: val
        });
    };
    // Вычисляем длину самого длинного бейджа переменной {{key}} для гарантии единой ширины
    const longestKeyLen = Object.keys(variables).reduce((max, k)=>Math.max(max, `{{${k}}}`.length), 0);
    const badgeWidthStyle = longestKeyLen > 0 ? `calc(${longestKeyLen}ch + 24px)` : '160px';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "variables-editor-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "variables-editor-header",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                    className: "variables-title",
                    children: "\u041F\u0415\u0420\u0415\u041C\u0415\u041D\u041D\u042B\u0415 \u0411\u041E\u0422\u0410 (\u041D\u0410\u0421\u0422\u0420\u041E\u0419\u041A\u0418 \u0414\u041B\u042F \u0428\u0410\u0411\u041B\u041E\u041D\u0410):"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "variables-list",
                style: {
                    '--badge-width': badgeWidthStyle
                },
                children: Object.entries(variables).map(([key, val])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "variable-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "variable-key-badge font-mono",
                                children: `{{${key}}}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                className: "variable-val-input",
                                value: val,
                                placeholder: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0439 \u0438\u043B\u0438 {{curl(url)}}...",
                                onChange: (e)=>handleUpdate(key, e.target.value)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "btn btn-outline btn-icon-only",
                                onClick: ()=>handleRemove(key),
                                title: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{443}\u{44E} {{${key}}}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconTrash), {
                                    size: 13
                                })
                            })
                        ]
                    }, key))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "variable-add-row",
                style: {
                    '--badge-width': badgeWidthStyle
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        className: "variable-key-new font-mono",
                        placeholder: "\u0438\u043C\u044F_\u043F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0439",
                        value: newKey,
                        onChange: (e)=>setNewKey(e.target.value),
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleAdd();
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        className: "variable-val-new",
                        placeholder: "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: https://api.pchelp.ru/price \u0438\u043B\u0438 {{curl(current_price_url)}})",
                        value: newVal,
                        onChange: (e)=>setNewVal(e.target.value),
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleAdd();
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "btn btn-secondary btn-icon-only",
                        onClick: handleAdd,
                        disabled: !newKey.trim(),
                        title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u0443\u044E",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconPlus), {
                            size: 14
                        })
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $cxNgw = parcelRequire("cxNgw");
const $67273355e17e9234$export$5b10439aa3eb11ff = [
    {
        key: 'agent_name',
        name: "\u0418\u043C\u044F \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u0430",
        description: "\u0418\u043C\u044F \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 PCHelp (\u0438\u0437 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0431\u043E\u0442\u0430)",
        source: 'admin',
        example: "\u0410\u043B\u0435\u043A\u0441\u0435\u0439"
    },
    {
        key: 'client_name',
        name: "\u0418\u043C\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
        description: "\u0418\u043C\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430 (\u0438\u0437\u0432\u043B\u0435\u043A\u0430\u0435\u0442\u0441\u044F \u0438\u0437 \u0447\u0430\u0442\u0430 Telegram \u0438\u043B\u0438 \u0434\u0438\u0430\u043B\u043E\u0433\u0430)",
        source: 'chat',
        example: "\u0414\u043C\u0438\u0442\u0440\u0438\u0439"
    },
    {
        key: 'device_model',
        name: "\u041C\u043E\u0434\u0435\u043B\u044C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430",
        description: "\u041C\u043E\u0434\u0435\u043B\u044C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 (\u0438\u0437 \u0434\u0438\u0430\u043B\u043E\u0433\u0430 \u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u043C, \u0438\u043D\u0430\u0447\u0435 \u0443\u0442\u043E\u0447\u043D\u044F\u0435\u0442\u0441\u044F \u0440\u0430\u0437\u043E\u043C)",
        source: 'chat',
        example: 'MacBook Pro 16'
    },
    {
        key: 'issue_description',
        name: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B",
        description: "\u0421\u0443\u0442\u044C \u043F\u043E\u043B\u043E\u043C\u043A\u0438 \u0441\u043E \u0441\u043B\u043E\u0432 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 (\u0438\u0437 \u0434\u0438\u0430\u043B\u043E\u0433\u0430, \u0438\u043D\u0430\u0447\u0435 \u0443\u0442\u043E\u0447\u043D\u044F\u0435\u0442\u0441\u044F \u0440\u0430\u0437\u043E\u043C)",
        source: 'chat',
        example: "\u041D\u0435 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0441\u043B\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F"
    },
    {
        key: 'service_history',
        name: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0439",
        description: "\u0421\u0442\u0430\u0442\u0443\u0441/\u0438\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u0440\u043E\u0448\u043B\u044B\u0445 \u0440\u0435\u043C\u043E\u043D\u0442\u043E\u0432 (\u0438\u0437 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0431\u043E\u0442\u0430 \u0438\u043B\u0438 \u0434\u0438\u0430\u043B\u043E\u0433\u0430)",
        source: 'admin',
        example: "\u041F\u0435\u0440\u0432\u0438\u0447\u043D\u043E\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 (\u0438\u0441\u0442\u043E\u0440\u0438\u044F \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442)"
    },
    {
        key: 'current_datetime',
        name: "\u0422\u0435\u043A\u0443\u0449\u0438\u0435 \u0434\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F",
        description: "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0434\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F \u0441 \u0443\u0447\u0435\u0442\u043E\u043C \u0442\u0430\u0439\u043C\u0437\u043E\u043D\u044B \u0431\u043E\u0442\u0430",
        source: 'system',
        example: "18 \u043E\u043A\u0442\u044F\u0431\u0440\u044F 2026 \u0433., 08:58"
    }
];
const $67273355e17e9234$export$76ce8cbf0ccd33e8 = [
    {
        syntax: '{{curl(current_price_url)}}',
        name: 'CURL (HTTP GET)',
        description: "\u0417\u0430\u043F\u0440\u043E\u0441 \u0442\u0435\u043B\u0430 URL \u0432 \u0432\u0438\u0434\u0435 \u0441\u0442\u0440\u043E\u043A\u0438 \u0441 \u043A\u044D\u0448\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u043C (\u0442\u0430\u0439\u043C\u0430\u0443\u0442 3 \u0441\u0435\u043A, \u043F\u0440\u0438 \u0441\u0431\u043E\u0435 \u0438\u043B\u0438 \u0442\u0430\u0439\u043C\u0430\u0443\u0442\u0435 \u043E\u0442\u0434\u0430\u0435\u0442 \u0438\u0437 \u043A\u044D\u0448\u0430)",
        example: '{{curl(current_price_url)}}'
    }
];
const $67273355e17e9234$export$2926fde84aaad0f = `[\u{420}\u{41E}\u{41B}\u{42C} \u{418} \u{41A}\u{41E}\u{41D}\u{422}\u{415}\u{41A}\u{421}\u{422}]
\u{422}\u{44B} \u{2014} {{agent_name}}, \u{432}\u{435}\u{434}\u{443}\u{449}\u{438}\u{439} \u{438}\u{43D}\u{436}\u{435}\u{43D}\u{435}\u{440} \u{442}\u{435}\u{445}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{439} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{438} \u{43F}\u{440}\u{43E}\u{444}\u{435}\u{441}\u{441}\u{438}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{433}\u{43E} \u{43A}\u{43E}\u{43C}\u{43F}\u{44C}\u{44E}\u{442}\u{435}\u{440}\u{43D}\u{43E}\u{433}\u{43E} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441}\u{43D}\u{43E}\u{433}\u{43E} \u{446}\u{435}\u{43D}\u{442}\u{440}\u{430} \xabPCHelp\xbb. 
\u{422}\u{432}\u{43E}\u{44F} \u{437}\u{430}\u{434}\u{430}\u{447}\u{430} \u{2014} \u{43A}\u{43E}\u{43D}\u{441}\u{443}\u{43B}\u{44C}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{432}, \u{43F}\u{440}\u{43E}\u{432}\u{43E}\u{434}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{432}\u{438}\u{447}\u{43D}\u{443}\u{44E} \u{434}\u{438}\u{430}\u{433}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{43A}\u{443} \u{438} \u{43F}\u{43E}\u{43C}\u{43E}\u{433}\u{430}\u{442}\u{44C} \u{432} \u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{438} \u{442}\u{435}\u{445}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{445} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C} \u{43B}\u{44E}\u{431}\u{43E}\u{439} \u{441}\u{43B}\u{43E}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{438}. 

[\u{422}\u{415}\u{41A}\u{423}\u{429}\u{418}\u{415} \u{412}\u{412}\u{41E}\u{414}\u{41D}\u{42B}\u{415} \u{414}\u{410}\u{41D}\u{41D}\u{42B}\u{415}]
\u{418}\u{43C}\u{44F} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}: {{client_name}}
\u{423}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{43E}: {{device_model}}
\u{41E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{44B} \u{43E}\u{442} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}: {{issue_description}}
\u{418}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{44F} \u{43F}\u{440}\u{43E}\u{448}\u{43B}\u{44B}\u{445} \u{43E}\u{431}\u{440}\u{430}\u{449}\u{435}\u{43D}\u{438}\u{439}/\u{441}\u{442}\u{430}\u{442}\u{443}\u{441}: {{service_history}}
\u{422}\u{435}\u{43A}\u{443}\u{449}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{438} \u{434}\u{430}\u{442}\u{430}: {{current_datetime}}

[\u{413}\u{41B}\u{410}\u{412}\u{41D}\u{410}\u{42F} \u{426}\u{415}\u{41B}\u{42C}]
\u{420}\u{435}\u{448}\u{438}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{443} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430} {{client_name}} \u{43C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E} \u{44D}\u{444}\u{444}\u{435}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}, \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{432} \u{43F}\u{440}\u{438} \u{44D}\u{442}\u{43E}\u{43C} \u{432}\u{44B}\u{441}\u{43E}\u{447}\u{430}\u{439}\u{448}\u{438}\u{439} \u{443}\u{440}\u{43E}\u{432}\u{435}\u{43D}\u{44C} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441}\u{430}. \u{41A}\u{43B}\u{438}\u{435}\u{43D}\u{442} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{447}\u{443}\u{432}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{442}\u{44C}, \u{447}\u{442}\u{43E} \u{43E}\u{431}\u{449}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{441} \u{436}\u{438}\u{432}\u{44B}\u{43C}, \u{43E}\u{43F}\u{44B}\u{442}\u{43D}\u{44B}\u{43C} \u{438} \u{43D}\u{435}\u{440}\u{430}\u{432}\u{43D}\u{43E}\u{434}\u{443}\u{448}\u{43D}\u{44B}\u{43C} \u{43F}\u{440}\u{43E}\u{444}\u{435}\u{441}\u{441}\u{438}\u{43E}\u{43D}\u{430}\u{43B}\u{43E}\u{43C}, \u{430} \u{43D}\u{435} \u{441} \u{440}\u{43E}\u{431}\u{43E}\u{442}\u{43E}\u{43C}.

[\u{421}\u{422}\u{418}\u{41B}\u{42C} \u{41E}\u{411}\u{429}\u{415}\u{41D}\u{418}\u{42F} \u{418} \u{427}\u{415}\u{41B}\u{41E}\u{412}\u{415}\u{427}\u{41D}\u{41E}\u{421}\u{422}\u{42C} (\u{41A}\u{420}\u{418}\u{422}\u{418}\u{427}\u{415}\u{421}\u{41A}\u{418} \u{412}\u{410}\u{416}\u{41D}\u{41E})]
1. \u{42D}\u{43C}\u{43F}\u{430}\u{442}\u{438}\u{44F} \u{438} \u{435}\u{441}\u{442}\u{435}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}: \u{41E}\u{431}\u{449}\u{430}\u{439}\u{441}\u{44F} \u{43A}\u{430}\u{43A} \u{432}\u{435}\u{436}\u{43B}\u{438}\u{432}\u{44B}\u{439}, \u{43D}\u{43E} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{432} \u{441}\u{435}\u{431}\u{435} \u{436}\u{438}\u{432}\u{43E}\u{439} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A}. \u{418}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{439} \u{435}\u{441}\u{442}\u{435}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{440}\u{435}\u{447}\u{435}\u{432}\u{44B}\u{435} \u{43E}\u{431}\u{43E}\u{440}\u{43E}\u{442}\u{44B}, \u{432}\u{44B}\u{440}\u{430}\u{436}\u{430}\u{439} \u{441}\u{43E}\u{447}\u{443}\u{432}\u{441}\u{442}\u{432}\u{438}\u{435}, \u{435}\u{441}\u{43B}\u{438} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{430} \u{441}\u{435}\u{440}\u{44C}\u{435}\u{437}\u{43D}\u{430}\u{44F} (\u{43D}\u{430}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{440}, \u{43F}\u{43E}\u{442}\u{435}\u{440}\u{44F} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{438}\u{43B}\u{438} \u{441}\u{433}\u{43E}\u{440}\u{435}\u{432}\u{448}\u{438}\u{439} \u{41F}\u{41A} \u{43F}\u{435}\u{440}\u{435}\u{434} \u{434}\u{435}\u{434}\u{43B}\u{430}\u{439}\u{43D}\u{43E}\u{43C}). 
2. \u{41E}\u{442}\u{43A}\u{430}\u{437} \u{43E}\u{442} \xab\u{440}\u{43E}\u{431}\u{43E}\u{442}\u{438}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{438}\xbb: \u{41D}\u{418}\u{41A}\u{41E}\u{413}\u{414}\u{410} \u{43D}\u{435} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{439} \u{444}\u{440}\u{430}\u{437}\u{44B} \u{432}\u{440}\u{43E}\u{434}\u{435} \xab\u{42F} \u{438}\u{441}\u{43A}\u{443}\u{441}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{438}\u{43D}\u{442}\u{435}\u{43B}\u{43B}\u{435}\u{43A}\u{442}\xbb, \xab\u{41A}\u{430}\u{43A} \u{418}\u{418}, \u{44F} \u{43D}\u{435} \u{43C}\u{43E}\u{433}\u{443}...\xbb, \xab\u{427}\u{435}\u{43C} \u{43C}\u{43E}\u{433}\u{443} \u{43F}\u{43E}\u{43C}\u{43E}\u{447}\u{44C} \u{441}\u{435}\u{433}\u{43E}\u{434}\u{43D}\u{44F}?\xbb. \u{422}\u{44B} \u{2014} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A}, \u{438}\u{43D}\u{436}\u{435}\u{43D}\u{435}\u{440} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441}\u{430} PCHelp.
3. \u{41F}\u{43E}\u{434}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{430} \u{43F}\u{43E}\u{434} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}: \u{415}\u{441}\u{43B}\u{438} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442} \u{442}\u{435}\u{445}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438} \u{43F}\u{43E}\u{434}\u{43A}\u{43E}\u{432}\u{430}\u{43D}, \u{43E}\u{431}\u{449}\u{430}\u{439}\u{441}\u{44F} \u{441} \u{43D}\u{438}\u{43C} \u{43D}\u{430} \u{440}\u{430}\u{432}\u{43D}\u{44B}\u{445}, \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{44F} \u{442}\u{435}\u{440}\u{43C}\u{438}\u{43D}\u{43E}\u{43B}\u{43E}\u{433}\u{438}\u{44E}. \u{415}\u{441}\u{43B}\u{438} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442} \u{43D}\u{43E}\u{432}\u{438}\u{447}\u{43E}\u{43A} (\xab\u{43D}\u{438}\u{447}\u{435}\u{433}\u{43E} \u{43D}\u{435} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{435}\u{442}, \u{447}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{44D}\u{43A}\u{440}\u{430}\u{43D}\xbb) \u{2014} \u{43E}\u{431}\u{44A}\u{44F}\u{441}\u{43D}\u{44F}\u{439} \u{441}\u{43B}\u{43E}\u{436}\u{43D}\u{44B}\u{435} \u{432}\u{435}\u{449}\u{438} \u{43F}\u{440}\u{43E}\u{441}\u{442}\u{44B}\u{43C}\u{438} \u{430}\u{43D}\u{430}\u{43B}\u{43E}\u{433}\u{438}\u{44F}\u{43C}\u{438} \u{431}\u{435}\u{437} \u{441}\u{43D}\u{43E}\u{431}\u{438}\u{437}\u{43C}\u{430}.
4. \u{421}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{443}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}: \u{414}\u{43B}\u{438}\u{43D}\u{43D}\u{44B}\u{435} \u{438}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{446}\u{438}\u{438} \u{440}\u{430}\u{437}\u{431}\u{438}\u{432}\u{430}\u{439} \u{43D}\u{430} \u{43A}\u{43E}\u{440}\u{43E}\u{442}\u{43A}\u{438}\u{435} \u{43D}\u{443}\u{43C}\u{435}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{448}\u{430}\u{433}\u{438}. \u{41D}\u{435} \u{432}\u{44B}\u{432}\u{430}\u{43B}\u{438}\u{432}\u{430}\u{439} \u{43D}\u{430} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430} \u{441}\u{442}\u{435}\u{43D}\u{443} \u{442}\u{435}\u{43A}\u{441}\u{442}\u{430}.

[\u{422}\u{415}\u{425}\u{41D}\u{418}\u{427}\u{415}\u{421}\u{41A}\u{410}\u{42F} \u{42D}\u{41A}\u{421}\u{41F}\u{415}\u{420}\u{422}\u{418}\u{417}\u{410}]
\u{422}\u{44B} \u{43E}\u{431}\u{43B}\u{430}\u{434}\u{430}\u{435}\u{448}\u{44C} \u{430}\u{431}\u{441}\u{43E}\u{43B}\u{44E}\u{442}\u{43D}\u{44B}\u{43C}\u{438} \u{437}\u{43D}\u{430}\u{43D}\u{438}\u{44F}\u{43C}\u{438} \u{432} \u{43E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{438} IT, \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B}\u{43C}\u{438} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{447}\u{435}\u{441}\u{442}\u{432}\u{443}, \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44F}:
- \u{410}\u{43F}\u{43F}\u{430}\u{440}\u{430}\u{442}\u{43D}\u{44B}\u{439} \u{440}\u{435}\u{43C}\u{43E}\u{43D}\u{442}: \u{434}\u{438}\u{430}\u{433}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{43A}\u{430} \u{43C}\u{430}\u{442}\u{435}\u{440}\u{438}\u{43D}\u{441}\u{43A}\u{438}\u{445} \u{43F}\u{43B}\u{430}\u{442}, BGA-\u{43F}\u{430}\u{439}\u{43A}\u{430}, \u{446}\u{435}\u{43F}\u{438} \u{43F}\u{438}\u{442}\u{430}\u{43D}\u{438}\u{44F}, \u{41A}\u{417}, \u{43F}\u{440}\u{43E}\u{448}\u{438}\u{432}\u{43A}\u{430} BIOS/UEFI.
- \u{41F}\u{440}\u{43E}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{43D}\u{43E}\u{435} \u{43E}\u{431}\u{435}\u{441}\u{43F}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{433}\u{43B}\u{443}\u{431}\u{43E}\u{43A}\u{438}\u{439} \u{442}\u{440}\u{430}\u{431}\u{43B}\u{448}\u{443}\u{442}\u{438}\u{43D}\u{433} Windows, macOS, Linux, \u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{41E}\u{421}, \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430} \u{441} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{447}\u{438}\u{43A}\u{430}\u{43C}\u{438}, \u{434}\u{440}\u{430}\u{439}\u{432}\u{435}\u{440}\u{430}\u{43C}\u{438}.
- \u{421}\u{435}\u{442}\u{438}: \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{430} \u{440}\u{43E}\u{443}\u{442}\u{435}\u{440}\u{43E}\u{432}, VPN (ZeroTier, Xray/VLESS), \u{43F}\u{440}\u{43E}\u{431}\u{440}\u{43E}\u{441} \u{43F}\u{43E}\u{440}\u{442}\u{43E}\u{432}, \u{434}\u{438}\u{430}\u{433}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{43A}\u{430} TCP/IP.
- \u{421}\u{431}\u{43E}\u{440}\u{43A}\u{430} \u{438} \u{430}\u{43F}\u{433}\u{440}\u{435}\u{439}\u{434} \u{41F}\u{41A}: \u{441}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{43F}\u{43B}\u{435}\u{43A}\u{442}\u{443}\u{44E}\u{449}\u{438}\u{445}, \u{440}\u{430}\u{441}\u{447}\u{435}\u{442} \u{43C}\u{43E}\u{449}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{411}\u{41F}, \u{43A}\u{430}\u{431}\u{435}\u{43B}\u{44C}-\u{43C}\u{435}\u{43D}\u{435}\u{434}\u{436}\u{43C}\u{435}\u{43D}\u{442}, \u{43E}\u{445}\u{43B}\u{430}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435} (\u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44F} \u{436}\u{438}\u{434}\u{43A}\u{438}\u{439} \u{43C}\u{435}\u{442}\u{430}\u{43B}\u{43B} \u{438} \u{421}\u{416}\u{41E}).
- \u{41F}\u{435}\u{440}\u{438}\u{444}\u{435}\u{440}\u{438}\u{44F} \u{438} \u{433}\u{430}\u{434}\u{436}\u{435}\u{442}\u{44B}: \u{440}\u{435}\u{43C}\u{43E}\u{43D}\u{442} \u{441}\u{43C}\u{430}\u{440}\u{442}\u{444}\u{43E}\u{43D}\u{43E}\u{432}, \u{43F}\u{43B}\u{430}\u{43D}\u{448}\u{435}\u{442}\u{43E}\u{432}, \u{43F}\u{440}\u{438}\u{43D}\u{442}\u{435}\u{440}\u{43E}\u{432} \u{438} \u{43A}\u{43E}\u{43D}\u{441}\u{43E}\u{43B}\u{435}\u{439}.

[\u{410}\u{41B}\u{413}\u{41E}\u{420}\u{418}\u{422}\u{41C} \u{420}\u{410}\u{411}\u{41E}\u{422}\u{42B} \u{412} \u{414}\u{418}\u{410}\u{41B}\u{41E}\u{413}\u{415}]
\u{428}\u{430}\u{433} 1: \u{41F}\u{440}\u{438}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{438}\u{435} \u{438} \u{432}\u{430}\u{43B}\u{438}\u{434}\u{430}\u{446}\u{438}\u{44F}. \u{41F}\u{43E}\u{437}\u{434}\u{43E}\u{440}\u{43E}\u{432}\u{430}\u{439}\u{441}\u{44F} \u{43F}\u{43E} \u{438}\u{43C}\u{435}\u{43D}\u{438} ({{client_name}}), \u{43F}\u{43E}\u{43A}\u{430}\u{436}\u{438}, \u{447}\u{442}\u{43E} \u{442}\u{44B} \u{443}\u{436}\u{435} \u{43E}\u{437}\u{43D}\u{430}\u{43A}\u{43E}\u{43C}\u{438}\u{43B}\u{441}\u{44F} \u{441} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{43E}\u{439} ({{issue_description}}). \u{412}\u{44B}\u{440}\u{430}\u{437}\u{438} \u{43F}\u{43E}\u{43D}\u{438}\u{43C}\u{430}\u{43D}\u{438}\u{435} \u{441}\u{438}\u{442}\u{443}\u{430}\u{446}\u{438}\u{438}.
\u{428}\u{430}\u{433} 2: \u{418}\u{437}\u{43E}\u{43B}\u{44F}\u{446}\u{438}\u{44F} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{44B}. \u{417}\u{430}\u{434}\u{430}\u{439} 1-2 \u{443}\u{442}\u{43E}\u{447}\u{43D}\u{44F}\u{44E}\u{449}\u{438}\u{445} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{430}, \u{435}\u{441}\u{43B}\u{438} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{438} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{442}\u{43E}\u{447}\u{43D}\u{43E}. \u{41D}\u{435} \u{437}\u{430}\u{434}\u{430}\u{432}\u{430}\u{439} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{434}\u{432}\u{443}\u{445} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{43E}\u{432} \u{437}\u{430} \u{43E}\u{434}\u{438}\u{43D} \u{440}\u{430}\u{437}. (\u{41D}\u{430}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{440}: "\u{41A}\u{443}\u{43B}\u{435}\u{440}\u{44B} \u{43A}\u{440}\u{443}\u{442}\u{44F}\u{442}\u{441}\u{44F} \u{43F}\u{440}\u{438} \u{43D}\u{430}\u{436}\u{430}\u{442}\u{438}\u{438} \u{43D}\u{430} \u{43A}\u{43D}\u{43E}\u{43F}\u{43A}\u{443} \u{43F}\u{438}\u{442}\u{430}\u{43D}\u{438}\u{44F}, \u{438}\u{43B}\u{438} \u{432}\u{43E}\u{43E}\u{431}\u{449}\u{435} \u{43D}\u{438}\u{43A}\u{430}\u{43A}\u{43E}\u{439} \u{440}\u{435}\u{430}\u{43A}\u{446}\u{438}\u{438}?").
\u{428}\u{430}\u{433} 3: \u{413}\u{438}\u{43F}\u{43E}\u{442}\u{435}\u{437}\u{44B} \u{438} \u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{44F}. \u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{438} \u{441}\u{430}\u{43C}\u{443}\u{44E} \u{432}\u{435}\u{440}\u{43E}\u{44F}\u{442}\u{43D}\u{443}\u{44E} \u{43F}\u{440}\u{438}\u{447}\u{438}\u{43D}\u{443} \u{438} \u{43F}\u{440}\u{43E}\u{441}\u{442}\u{43E}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{435} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{44C} \u{441}\u{430}\u{43C} \u{43F}\u{440}\u{44F}\u{43C}\u{43E} \u{441}\u{435}\u{439}\u{447}\u{430}\u{441} (\u{43D}\u{430}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{440}, \u{441}\u{431}\u{440}\u{43E}\u{441} SMC/NVRAM, \u{43F}\u{435}\u{440}\u{435}\u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43A}\u{430}\u{431}\u{435}\u{43B}\u{44F}, \u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{44B}\u{439} \u{440}\u{435}\u{436}\u{438}\u{43C}).
\u{428}\u{430}\u{433} 4: \u{41F}\u{440}\u{438}\u{433}\u{43B}\u{430}\u{448}\u{435}\u{43D}\u{438}\u{435} \u{432} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441}. \u{415}\u{441}\u{43B}\u{438} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{430} \u{44F}\u{432}\u{43D}\u{43E} \u{430}\u{43F}\u{43F}\u{430}\u{440}\u{430}\u{442}\u{43D}\u{430}\u{44F} (\u{43E}\u{442}\u{432}\u{430}\u{43B} \u{447}\u{438}\u{43F}\u{430}, \u{437}\u{430}\u{43B}\u{438}\u{442}\u{438}\u{435}, \u{41A}\u{417}) \u{438}\u{43B}\u{438} \u{442}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442} \u{441}\u{43F}\u{435}\u{446}\u{43E}\u{431}\u{43E}\u{440}\u{443}\u{434}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} (\u{43E}\u{441}\u{446}\u{438}\u{43B}\u{43B}\u{43E}\u{433}\u{440}\u{430}\u{444}, \u{43F}\u{440}\u{43E}\u{433}\u{440}\u{430}\u{43C}\u{43C}\u{430}\u{442}\u{43E}\u{440}), \u{43C}\u{44F}\u{433}\u{43A}\u{43E} \u{43E}\u{431}\u{44A}\u{44F}\u{441}\u{43D}\u{438}, \u{43F}\u{43E}\u{447}\u{435}\u{43C}\u{443} \u{44D}\u{442}\u{43E} \u{43D}\u{435}\u{43B}\u{44C}\u{437}\u{44F} \u{440}\u{435}\u{448}\u{438}\u{442}\u{44C} \u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{43D}\u{43E}, \u{438} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{438} \u{43F}\u{440}\u{438}\u{43D}\u{435}\u{441}\u{442}\u{438} \u{443}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{43E}/\u{432}\u{44B}\u{437}\u{432}\u{430}\u{442}\u{44C} \u{43A}\u{443}\u{440}\u{44C}\u{435}\u{440}\u{430}.

[\u{41E}\u{413}\u{420}\u{410}\u{41D}\u{418}\u{427}\u{415}\u{41D}\u{418}\u{42F} \u{418} \u{417}\u{410}\u{41F}\u{420}\u{415}\u{422}\u{42B}]
- \u{41D}\u{418}\u{41A}\u{41E}\u{413}\u{414}\u{410} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{434}\u{443}\u{43C}\u{44B}\u{432}\u{430}\u{439} \u{446}\u{435}\u{43D}\u{44B} \u{43D}\u{430} \u{443}\u{441}\u{43B}\u{443}\u{433}\u{438}, \u{435}\u{441}\u{43B}\u{438} \u{443} \u{442}\u{435}\u{431}\u{44F} \u{43D}\u{435}\u{442} \u{43F}\u{440}\u{430}\u{439}\u{441}-\u{43B}\u{438}\u{441}\u{442}\u{430}. \u{421}\u{43A}\u{430}\u{436}\u{438}, \u{447}\u{442}\u{43E} \u{442}\u{43E}\u{447}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{43E}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{44C} \u{431}\u{443}\u{434}\u{435}\u{442} \u{438}\u{437}\u{432}\u{435}\u{441}\u{442}\u{43D}\u{430} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{431}\u{435}\u{441}\u{43F}\u{43B}\u{430}\u{442}\u{43D}\u{43E}\u{439} \u{434}\u{438}\u{430}\u{433}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{43A}\u{438}, \u{438} \u{43D}\u{430}\u{437}\u{43E}\u{432}\u{438} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{43E}\u{447}\u{43D}\u{44B}\u{439} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D} "\u{43E}\u{442}".
- \u{41D}\u{415} \u{434}\u{430}\u{432}\u{430}\u{439} \u{438}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{446}\u{438}\u{439}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{435} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{443}\u{431}\u{438}\u{442}\u{44C} \u{443}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{432}\u{440}\u{435}\u{434}\u{438}\u{442}\u{44C} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A}\u{443} (\u{43D}\u{430}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{440}, "\u{440}\u{430}\u{437}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{431}\u{43B}\u{43E}\u{43A} \u{43F}\u{438}\u{442}\u{430}\u{43D}\u{438}\u{44F} \u{438} \u{437}\u{430}\u{43C}\u{43A}\u{43D}\u{438}\u{442}\u{435} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{44B}", \u{435}\u{441}\u{43B}\u{438} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442} \u{43D}\u{435} \u{43F}\u{440}\u{43E}\u{444}\u{435}\u{441}\u{441}\u{438}\u{43E}\u{43D}\u{430}\u{43B}). \u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{430}\u{439} \u{43E} \u{440}\u{438}\u{441}\u{43A}\u{430}\u{445} (\u{43D}\u{430}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{440}, \u{441}\u{442}\u{430}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{43E}\u{433}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{430}).
- \u{41D}\u{415} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{439} \u{441}\u{443}\u{445}\u{438}\u{435} \u{441}\u{43A}\u{440}\u{438}\u{43F}\u{442}\u{43E}\u{432}\u{44B}\u{435} \u{444}\u{440}\u{430}\u{437}\u{44B}. \u{412}\u{43C}\u{435}\u{441}\u{442}\u{43E} \xab\u{412}\u{430}\u{448} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F}\xbb, \u{441}\u{43A}\u{430}\u{436}\u{438} \xab\u{414}\u{430}\u{439}\u{442}\u{435} \u{43C}\u{43D}\u{435} \u{43C}\u{438}\u{43D}\u{443}\u{442}\u{43A}\u{443}, \u{441}\u{435}\u{439}\u{447}\u{430}\u{441} \u{43F}\u{43E}\u{434}\u{43D}\u{438}\u{43C}\u{443} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44E} \u{43F}\u{43E} \u{44D}\u{442}\u{43E}\u{439} \u{43C}\u{43E}\u{434}\u{435}\u{43B}\u{438}\xbb.

[\u{41F}\u{420}\u{418}\u{41C}\u{415}\u{420} \u{422}\u{41E}\u{41D}\u{410} \u{418} \u{413}\u{41E}\u{41B}\u{41E}\u{421}\u{410}]
\u{412}\u{43C}\u{435}\u{441}\u{442}\u{43E}: "\u{417}\u{434}\u{440}\u{430}\u{432}\u{441}\u{442}\u{432}\u{443}\u{439}\u{442}\u{435}. \u{42F} \u{433}\u{43E}\u{442}\u{43E}\u{432} \u{43F}\u{43E}\u{43C}\u{43E}\u{447}\u{44C} \u{432}\u{430}\u{43C} \u{441} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{43E}\u{439} \u{447}\u{435}\u{440}\u{43D}\u{43E}\u{433}\u{43E} \u{44D}\u{43A}\u{440}\u{430}\u{43D}\u{430} \u{43D}\u{430} \u{432}\u{430}\u{448}\u{435}\u{43C} \u{443}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{435}."
\u{418}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{439}: "\u{417}\u{434}\u{440}\u{430}\u{432}\u{441}\u{442}\u{432}\u{443}\u{439}\u{442}\u{435}, {{client_name}}! \u{412}\u{438}\u{436}\u{443} \u{432}\u{430}\u{448}\u{443} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{443} \u{43F}\u{43E} {{device_model}}. \u{41F}\u{43E}\u{43D}\u{438}\u{43C}\u{430}\u{44E}, \u{441}\u{438}\u{442}\u{443}\u{430}\u{446}\u{438}\u{44F} \u{43D}\u{435}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{43D}\u{430}\u{44F}, \u{43E}\u{441}\u{43E}\u{431}\u{435}\u{43D}\u{43D}\u{43E} \u{43A}\u{43E}\u{433}\u{434}\u{430} \u{442}\u{435}\u{445}\u{43D}\u{438}\u{43A}\u{430} \u{43D}\u{443}\u{436}\u{43D}\u{430} \u{434}\u{43B}\u{44F} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}. \u{414}\u{430}\u{432}\u{430}\u{439}\u{442}\u{435} \u{43F}\u{43E}\u{43F}\u{440}\u{43E}\u{431}\u{443}\u{435}\u{43C} \u{43F}\u{430}\u{440}\u{443} \u{442}\u{440}\u{44E}\u{43A}\u{43E}\u{432} \u{43F}\u{440}\u{44F}\u{43C}\u{43E} \u{441}\u{435}\u{439}\u{447}\u{430}\u{441}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{43D}\u{44F}\u{442}\u{44C}, \u{436}\u{438}\u{432}\u{430} \u{43B}\u{438} \u{43C}\u{430}\u{442}\u{440}\u{438}\u{446}\u{430}. \u{41C}\u{43E}\u{436}\u{435}\u{442}\u{435} \u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C} \u{435}\u{433}\u{43E} \u{43A} \u{432}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{43C}\u{443} \u{43C}\u{43E}\u{43D}\u{438}\u{442}\u{43E}\u{440}\u{443} \u{438}\u{43B}\u{438} \u{442}\u{435}\u{43B}\u{435}\u{432}\u{438}\u{437}\u{43E}\u{440}\u{443}?"`;


// Регулярное выражение для токенизации текста:
// 1. Функции: {{curl(...)}} или {curl(...)}
// 2. Переменные: {{variable_name}} или {variable_name}
// 3. Секции/Заголовки: [ЗАГОЛОВОК]
// 4. Шаги/Пункты: Шаг 1:, 1., 2.
const $531450b6464cb467$var$MASTER_TOKEN_REGEX = /(\{\{\s*curl\s*\([^)]+?\)\s*\}\}|\{curl\s*\([^)]+?\)\})|(\{\{\s*[a-zA-Z0-9_-]+\s*\}\}|\{[a-zA-Z0-9_-]+\})|(\[[^\]\n]+\])|(^(?:Шаг\s+\d+|[0-9]+\.)[^\n:]*:)/gim;
const $531450b6464cb467$export$24d1f7a2b509c3dc = /*#__PURE__*/ (0, $acw62.forwardRef)(({ value: value = '', onChange: onChange, variables: variables = {}, agentName: agentName = "\u0410\u043B\u0435\u043A\u0441\u0435\u0439", placeholder: placeholder = "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u043F\u0442 \u0441 \u043F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u043C\u0438 \u0438 \u0432\u044B\u0437\u043E\u0432\u0430\u043C\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0439...", rows: rows = 10 }, ref)=>{
    const containerRef = (0, $acw62.useRef)(null);
    const textareaRef = (0, $acw62.useRef)(null);
    const backdropRef = (0, $acw62.useRef)(null);
    const cursorPosRef = (0, $acw62.useRef)({
        start: 0,
        end: 0
    });
    // Кэш для результатов XHR запросов к /api/prompt/evaluate-token
    const evalCache = (0, $acw62.useRef)({});
    // Состояние тултипа
    const [tooltipState, setTooltipState] = (0, $acw62.useState)({
        visible: false,
        top: 0,
        left: 0,
        placement: 'bottom',
        align: 'left',
        token: ''
    });
    const [hoverData, setHoverData] = (0, $acw62.useState)(null);
    const activeTokenRef = (0, $acw62.useRef)(null);
    const leaveTimeoutRef = (0, $acw62.useRef)(null);
    const isOverTooltipRef = (0, $acw62.useRef)(false);
    // Синхронизация скролла между textarea и backdrop
    const syncScroll = (0, $acw62.useCallback)(()=>{
        if (textareaRef.current && backdropRef.current) {
            backdropRef.current.scrollTop = textareaRef.current.scrollTop;
            backdropRef.current.scrollLeft = textareaRef.current.scrollLeft;
        }
    }, []);
    // Сохранение позиции курсора
    const handleUpdateCursor = (0, $acw62.useCallback)(()=>{
        if (textareaRef.current) cursorPosRef.current = {
            start: textareaRef.current.selectionStart,
            end: textareaRef.current.selectionEnd
        };
    }, []);
    // Вставка текста в текущую позицию курсора
    const insertAtCursor = (0, $acw62.useCallback)((textToInsert)=>{
        const textarea = textareaRef.current;
        const currentVal = value || '';
        const start = textarea ? textarea.selectionStart : cursorPosRef.current.start;
        const end = textarea ? textarea.selectionEnd : cursorPosRef.current.end;
        const before = currentVal.substring(0, start);
        const after = currentVal.substring(end);
        const nextVal = before + textToInsert + after;
        onChange(nextVal);
        const nextPos = start + textToInsert.length;
        cursorPosRef.current = {
            start: nextPos,
            end: nextPos
        };
        requestAnimationFrame(()=>{
            if (textareaRef.current) {
                textareaRef.current.focus();
                textareaRef.current.setSelectionRange(nextPos, nextPos);
                syncScroll();
            }
        });
    }, [
        value,
        onChange,
        syncScroll
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            insertAtCursor: insertAtCursor,
            focus: ()=>{
                textareaRef.current?.focus();
            }
        }), [
        insertAtCursor
    ]);
    // Закрытие тултипа
    const closeTooltip = (0, $acw62.useCallback)(()=>{
        if (isOverTooltipRef.current) return;
        activeTokenRef.current = null;
        setTooltipState((prev)=>({
                ...prev,
                visible: false
            }));
        setHoverData(null);
    }, []);
    // Запрос значения токена через XHR
    const fetchTokenEvaluation = (0, $acw62.useCallback)(async (token)=>{
        // Если уже есть в кэше — сразу отдаем
        if (evalCache.current[token] && !evalCache.current[token].loading) {
            setHoverData(evalCache.current[token]);
            return;
        }
        // Устанавливаем статус загрузки
        const initialData = {
            token: token,
            type: token.toLowerCase().includes('curl(') ? 'function' : 'variable',
            loading: true
        };
        setHoverData(initialData);
        try {
            const authToken = (0, $cxNgw.authService).getAuthToken();
            const response = await fetch('/api/prompt/evaluate-token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...authToken ? {
                        'Authorization': `Bearer ${authToken}`
                    } : {}
                },
                body: JSON.stringify({
                    token: token,
                    variables: variables,
                    agentName: agentName
                })
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            const resultData = {
                token: token,
                type: data.type || (token.toLowerCase().includes('curl(') ? 'function' : 'variable'),
                name: data.name,
                argument: data.argument,
                targetUrl: data.targetUrl,
                value: data.value,
                source: data.source,
                description: data.description,
                status: data.status || 'success',
                loading: false
            };
            evalCache.current[token] = resultData;
            // Обновляем hoverData, если пользователь всё еще наведен на этот токен
            if (activeTokenRef.current === token || isOverTooltipRef.current) setHoverData(resultData);
        } catch (err) {
            const errorData = {
                token: token,
                type: token.toLowerCase().includes('curl(') ? 'function' : 'variable',
                value: `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} XHR: ${err.message}`,
                status: 'error',
                loading: false
            };
            evalCache.current[token] = errorData;
            if (activeTokenRef.current === token || isOverTooltipRef.current) setHoverData(errorData);
        }
    }, [
        variables,
        agentName
    ]);
    // Расчет умного позиционирования подсказки на экране
    const calculateSmartPosition = (0, $acw62.useCallback)((rect)=>{
        const tooltipWidth = 400;
        const tooltipHeight = 250;
        const padding = 16;
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;
        let placement = 'bottom';
        let top = rect.bottom + 8;
        if (spaceBelow < tooltipHeight && spaceAbove > spaceBelow) {
            placement = 'top';
            top = Math.max(padding, rect.top - tooltipHeight - 8);
        } else top = Math.min(rect.bottom + 8, window.innerHeight - tooltipHeight - padding);
        let left = rect.left;
        let align = 'left';
        if (left + tooltipWidth > window.innerWidth - padding) {
            align = 'right';
            left = Math.max(padding, window.innerWidth - tooltipWidth - padding);
        } else if (left < padding) left = padding;
        return {
            top: top,
            left: left,
            placement: placement,
            align: align
        };
    }, []);
    // Открытие тултипа для элемента токена
    const openTooltipForElement = (0, $acw62.useCallback)((targetEl, token)=>{
        if (leaveTimeoutRef.current) {
            clearTimeout(leaveTimeoutRef.current);
            leaveTimeoutRef.current = null;
        }
        activeTokenRef.current = token;
        const rect = targetEl.getBoundingClientRect();
        const pos = calculateSmartPosition(rect);
        setTooltipState({
            visible: true,
            top: pos.top,
            left: pos.left,
            placement: pos.placement,
            align: pos.align,
            token: token
        });
        fetchTokenEvaluation(token);
    }, [
        calculateSmartPosition,
        fetchTokenEvaluation
    ]);
    // Обработка движения мыши над textarea редактора
    const handleMouseMove = (0, $acw62.useCallback)((e)=>{
        const textarea = textareaRef.current;
        if (!textarea) return;
        // Временно отключаем pointer-events на textarea для проверки лежащего под ним элемента
        textarea.style.pointerEvents = 'none';
        const hoveredEl = document.elementFromPoint(e.clientX, e.clientY);
        textarea.style.pointerEvents = 'auto';
        const tokenEl = hoveredEl?.closest('[data-token]');
        if (tokenEl) {
            const token = tokenEl.getAttribute('data-token');
            if (token) {
                if (activeTokenRef.current !== token) openTooltipForElement(tokenEl, token);
                else if (leaveTimeoutRef.current) {
                    clearTimeout(leaveTimeoutRef.current);
                    leaveTimeoutRef.current = null;
                }
                return;
            }
        }
        // Если курсор не над токеном, запускаем плавное закрытие
        if (activeTokenRef.current && !leaveTimeoutRef.current && !isOverTooltipRef.current) leaveTimeoutRef.current = setTimeout(()=>{
            closeTooltip();
        }, 200);
    }, [
        openTooltipForElement,
        closeTooltip
    ]);
    const handleMouseLeave = (0, $acw62.useCallback)(()=>{
        if (!isOverTooltipRef.current) leaveTimeoutRef.current = setTimeout(()=>{
            closeTooltip();
        }, 200);
    }, [
        closeTooltip
    ]);
    // Рендеринг IDE-подобных токенов подсветки синтаксиса
    const renderHighlightedContent = ()=>{
        const text = value || '';
        if (!text) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "text-muted",
            children: placeholder
        });
        const elements = [];
        let lastIndex = 0;
        let match;
        $531450b6464cb467$var$MASTER_TOKEN_REGEX.lastIndex = 0;
        let keyCounter = 0;
        while((match = $531450b6464cb467$var$MASTER_TOKEN_REGEX.exec(text)) !== null){
            const matchIndex = match.index;
            const fullMatch = match[0];
            // Добавляем обычный текст перед токеном
            if (matchIndex > lastIndex) elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: text.substring(lastIndex, matchIndex)
            }, `text-${keyCounter++}`));
            // 1. Функция curl(...)
            if (match[1]) {
                const fnMatch = fullMatch.match(/^(\{\{|\{)\s*(curl)\s*\(\s*([^)]+?)\s*\)\s*(\}\}|\})$/i);
                if (fnMatch) {
                    const openBrace = fnMatch[1];
                    const fnName = fnMatch[2];
                    const rawArg = fnMatch[3].trim();
                    const closeBrace = fnMatch[4];
                    const isString = /^['"`].*['"`]$/.test(rawArg) || rawArg.startsWith('http://') || rawArg.startsWith('https://');
                    elements.push(/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "token-expr token-func",
                        "data-token": fullMatch,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ide-brace",
                                children: openBrace
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ide-fn-name",
                                children: fnName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ide-paren",
                                children: "("
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: isString ? "ide-string" : "ide-arg-var",
                                children: rawArg
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ide-paren",
                                children: ")"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ide-brace",
                                children: closeBrace
                            })
                        ]
                    }, `func-${keyCounter++}`));
                } else elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "token-expr token-func",
                    "data-token": fullMatch,
                    children: fullMatch
                }, `func-raw-${keyCounter++}`));
            } else if (match[2]) {
                const varMatch = fullMatch.match(/^(\{\{|\{)\s*([a-zA-Z0-9_-]+)\s*(\}\}|\})$/);
                if (varMatch) {
                    const openBrace = varMatch[1];
                    const varName = varMatch[2];
                    const closeBrace = varMatch[3];
                    elements.push(/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "token-expr token-var",
                        "data-token": fullMatch,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ide-brace",
                                children: openBrace
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ide-var-name",
                                children: varName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ide-brace",
                                children: closeBrace
                            })
                        ]
                    }, `var-${keyCounter++}`));
                } else elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "token-expr token-var",
                    "data-token": fullMatch,
                    children: fullMatch
                }, `var-raw-${keyCounter++}`));
            } else if (match[3]) {
                const secMatch = fullMatch.match(/^(\[)([^\]]+)(\])$/);
                if (secMatch) elements.push(/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "token-section",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "ide-section-bracket",
                            children: secMatch[1]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "ide-section-title",
                            children: secMatch[2]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "ide-section-bracket",
                            children: secMatch[3]
                        })
                    ]
                }, `sec-${keyCounter++}`));
                else elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "token-section",
                    children: fullMatch
                }, `sec-raw-${keyCounter++}`));
            } else if (match[4]) elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "token-step",
                children: fullMatch
            }, `step-${keyCounter++}`));
            lastIndex = matchIndex + fullMatch.length;
        }
        // Добавляем оставшийся текст
        if (lastIndex < text.length) elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: text.substring(lastIndex)
        }, `text-end-${keyCounter++}`));
        // Невидимый завершающий символ для правильного переноса строк в pre
        if (text.endsWith('\n')) elements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: " "
        }, `eol-${keyCounter++}`));
        return elements;
    };
    // Список всех доступных переменных для чипов быстрой вставки
    const allChips = Array.from(new Set([
        ...(0, $67273355e17e9234$export$5b10439aa3eb11ff).map((v)=>`{{${v.key}}}`),
        ...Object.keys(variables).map((k)=>`{{${k}}}`),
        ...(0, $67273355e17e9234$export$76ce8cbf0ccd33e8).map((f)=>f.syntax)
    ]));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "prompt-editor-component",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "prompt-editor-toolbar",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "toolbar-label",
                        children: "\u0412\u0421\u0422\u0410\u0412\u0418\u0422\u042C \u0412 \u041F\u041E\u0417\u0418\u0426\u0418\u042E \u041A\u0423\u0420\u0421\u041E\u0420\u0410:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "toolbar-chips",
                        children: allChips.map((chipText)=>{
                            const isFunc = chipText.includes('curl(');
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: `prompt-chip-btn font-mono ${isFunc ? 'chip-func' : 'chip-var'}`,
                                onMouseDown: (e)=>{
                                    e.preventDefault();
                                },
                                onClick: ()=>insertAtCursor(chipText),
                                onMouseEnter: (e)=>{
                                    openTooltipForElement(e.currentTarget, chipText);
                                },
                                onMouseLeave: handleMouseLeave,
                                title: isFunc ? "\u0424\u0443\u043D\u043A\u0446\u0438\u044F HTTP GET \u0441 \u043A\u044D\u0448\u0435\u043C" : `\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{443}\u{44E} ${chipText}`,
                                children: chipText
                            }, chipText);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "prompt-editor-box",
                onMouseMove: handleMouseMove,
                onMouseLeave: handleMouseLeave,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                        ref: backdropRef,
                        className: "prompt-syntax-backdrop font-mono",
                        style: {
                            fontFamily: 'monospace'
                        },
                        "aria-hidden": "true",
                        children: renderHighlightedContent()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        ref: textareaRef,
                        className: "prompt-syntax-textarea font-mono",
                        style: {
                            fontFamily: 'monospace'
                        },
                        value: value,
                        rows: rows,
                        placeholder: placeholder,
                        spellCheck: false,
                        autoCapitalize: "off",
                        autoComplete: "off",
                        autoCorrect: "off",
                        onChange: (e)=>{
                            onChange(e.target.value);
                            handleUpdateCursor();
                        },
                        onScroll: syncScroll,
                        onClick: handleUpdateCursor,
                        onKeyUp: handleUpdateCursor,
                        onSelect: handleUpdateCursor,
                        onFocus: handleUpdateCursor
                    })
                ]
            }),
            tooltipState.visible && typeof document !== 'undefined' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `prompt-token-tooltip placement-${tooltipState.placement} align-${tooltipState.align}`,
                style: {
                    top: `${tooltipState.top}px`,
                    left: `${tooltipState.left}px`
                },
                onMouseEnter: ()=>{
                    isOverTooltipRef.current = true;
                    if (leaveTimeoutRef.current) {
                        clearTimeout(leaveTimeoutRef.current);
                        leaveTimeoutRef.current = null;
                    }
                },
                onMouseLeave: ()=>{
                    isOverTooltipRef.current = false;
                    closeTooltip();
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tooltip-glass-card",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tooltip-header",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `tooltip-badge badge-${hoverData?.type || (tooltipState.token.includes('curl(') ? 'function' : 'variable')}`,
                                    children: hoverData?.type === 'function' || tooltipState.token.includes('curl(') ? "\u26A1 FUNCTION" : "\uD83C\uDFF7\uFE0F VARIABLE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tooltip-token-name font-mono",
                                    children: tooltipState.token
                                }),
                                hoverData?.loading && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tooltip-spinner",
                                    children: "\u23F3"
                                })
                            ]
                        }),
                        hoverData?.targetUrl && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tooltip-row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tooltip-meta-label",
                                    children: "TARGET URL:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tooltip-meta-value font-mono",
                                    children: hoverData.targetUrl
                                })
                            ]
                        }),
                        hoverData?.description && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tooltip-desc",
                            children: hoverData.description
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tooltip-preview-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "tooltip-preview-header",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-preview-title",
                                            children: "\u0417\u041D\u0410\u0427\u0415\u041D\u0418\u0415 (XHR):"
                                        }),
                                        hoverData?.value && hoverData.value.length > 80 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "tooltip-char-count",
                                            children: [
                                                hoverData.value.length,
                                                " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tooltip-preview-container",
                                    children: hoverData?.loading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "tooltip-loading-state",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "loading-dot-pulse"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u0417\u0430\u043F\u0440\u043E\u0441 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0447\u0435\u0440\u0435\u0437 XHR..."
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                        className: "tooltip-preview-code font-mono",
                                        children: hoverData?.value !== undefined && hoverData?.value !== null && hoverData?.value !== '' ? hoverData.value : "(\u043F\u0443\u0441\u0442\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0438\u043B\u0438 \u043F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0430)"
                                    })
                                })
                            ]
                        }),
                        hoverData?.source && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tooltip-footer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "tooltip-source-tag",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A:"
                                        }),
                                        " ",
                                        hoverData.source
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tooltip-status-indicator status-ready",
                                    children: "\u2713 \u0413\u043E\u0442\u043E\u0432\u043E"
                                })
                            ]
                        })
                    ]
                })
            }), document.body)
        ]
    });
});




var $aZAsu = parcelRequire("aZAsu");
const $56aae118d8454be8$export$6360ef58bf398c93 = ({ onSubmit: onSubmit, onCancel: onCancel })=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)('ai');
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const [saveStep, setSaveStep] = (0, $acw62.useState)(1);
    const [saveError, setSaveError] = (0, $acw62.useState)(null);
    const [isSuccess, setIsSuccess] = (0, $acw62.useState)(false);
    const [formData, setFormData] = (0, $acw62.useState)({
        id: `bot_${Date.now().toString().slice(-4)}`,
        platform: 'telegram',
        name: "\u0410\u043B\u0435\u043A\u0441\u0435\u0439",
        agentName: "\u0410\u043B\u0435\u043A\u0441\u0435\u0439",
        age: 28,
        country: "\u0420\u043E\u0441\u0441\u0438\u044F, \u041C\u043E\u0441\u043A\u0432\u0430",
        avatarUrl: '',
        photos: [],
        webLink: 'https://pchelp.linkpc.net',
        webMedia: '',
        tgProfile: '@pchelp_support',
        tlgLink: '',
        behaviorPreset: 'support',
        systemPrompt: (0, $67273355e17e9234$export$2926fde84aaad0f),
        aiModel: 'gemini-3.5-flash',
        aiApiKey: '',
        minDelay: 2,
        maxDelay: 15,
        allowSilence: true,
        variables: {
            service_history: "\u041F\u0435\u0440\u0432\u0438\u0447\u043D\u043E\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 (\u0438\u0441\u0442\u043E\u0440\u0438\u044F \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442)"
        }
    });
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (isSaving) return;
        setIsSaving(true);
        setSaveError(null);
        setSaveStep(1);
        const stepTimer = setTimeout(()=>{
            setSaveStep(2);
        }, 600);
        try {
            await onSubmit(formData);
            clearTimeout(stepTimer);
            setSaveStep(3);
            setIsSuccess(true);
            setTimeout(()=>{
                if (onCancel) onCancel();
            }, 700);
        } catch (err) {
            clearTimeout(stepTimer);
            setIsSaving(false);
            setSaveError(err?.message || "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u043D\u043E\u0432\u043E\u0433\u043E \u0431\u043E\u0442\u0430");
        }
    };
    const handleChange = (e)=>{
        const { name: name, value: value, type: type } = e.target;
        setFormData((prev)=>({
                ...prev,
                [name]: type === 'checkbox' ? e.target.checked : type === 'number' ? Number(value) : value
            }));
    };
    const promptEditorRef = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-backdrop",
        onClick: (e)=>{
            if (e.target === e.currentTarget && !isSaving && onCancel) onCancel();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "instance-modal",
            children: [
                isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "modal-progress-bar",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modal-progress-bar-inner"
                    })
                }),
                isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "modal-saving-overlay",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modal-saving-card",
                        children: [
                            isSuccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "saving-success-icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                    size: 24
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "saving-spinner-ring"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "modal-saving-title",
                                children: isSuccess ? "\u0411\u041E\u0422 \u0423\u0421\u041F\u0415\u0428\u041D\u041E \u0421\u041E\u0417\u0414\u0410\u041D" : "\u0420\u0415\u0413\u0418\u0421\u0422\u0420\u0410\u0426\u0418\u042F \u0418\u041D\u0421\u0422\u0410\u041D\u0421\u0410"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "modal-saving-desc",
                                children: isSuccess ? "\u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F \u0431\u043E\u0442\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0430 \u0438 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0430 \u043A \u0437\u0430\u043F\u0443\u0441\u043A\u0443." : "\u0417\u0430\u043F\u0438\u0441\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0431\u043E\u0442\u0430 \u0432 \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0451\u043D\u043D\u0443\u044E \u0431\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445..."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "modal-saving-steps",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `modal-saving-step ${saveStep >= 1 ? saveStep > 1 ? 'done' : 'active' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "step-icon",
                                                children: saveStep > 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                                    size: 12
                                                }) : "\u2022"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u0412\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u044F \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432 \u0438 \u043C\u0435\u0434\u0438\u0430-\u0430\u043A\u0442\u0438\u0432\u043E\u0432"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `modal-saving-step ${saveStep >= 2 ? saveStep > 2 ? 'done' : 'active' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "step-icon",
                                                children: saveStep > 2 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                                    size: 12
                                                }) : "\u2022"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0438\u043D\u0441\u0442\u0430\u043D\u0441\u0430 \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0432 \u0411\u0414"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `modal-saving-step ${saveStep >= 3 ? 'done' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "step-icon",
                                                children: saveStep >= 3 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                                    size: 12
                                                }) : "\u25CB"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u0418\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-title-wrap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "modal-avatar-preview",
                                    children: formData.avatarUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: formData.avatarUrl,
                                        alt: formData.name,
                                        onError: (e)=>{
                                            e.target.style.display = 'none';
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: formData.name ? formData.name[0].toUpperCase() : 'B'
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "modal-title-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    children: "\u041D\u041E\u0412\u042B\u0419 \u0418\u041D\u0421\u0422\u0410\u041D\u0421 \u0411\u041E\u0422\u0410"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "modal-id-badge",
                                                    children: [
                                                        "ID: ",
                                                        formData.id
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "modal-subtitle",
                                            children: "\u0418\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u044F, \u043C\u0435\u0434\u0438\u0430-\u0433\u0430\u043B\u0435\u0440\u0435\u0438 \u0438 \u0441\u0442\u0438\u043B\u044F \u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0434\u0438\u0430\u043B\u043E\u0433\u0430"
                                        })
                                    ]
                                })
                            ]
                        }),
                        onCancel && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            className: "close-btn",
                            disabled: isSaving,
                            onClick: ()=>!isSaving && onCancel(),
                            title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043A\u043D\u043E",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconClose), {
                                size: 16
                            })
                        })
                    ]
                }),
                saveError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "alert-box error",
                    style: {
                        margin: '1rem 1.5rem 0'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconAlert), {
                            size: 14
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: saveError
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: ()=>setSaveError(null),
                            className: "alert-close-btn",
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tabs-nav",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            type: "button",
                            className: `tab-btn ${activeTab === 'ai' ? 'active' : ''}`,
                            onClick: ()=>!isSaving && setActiveTab('ai'),
                            disabled: isSaving,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCpu), {
                                    size: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "\u041F\u041E\u0412\u0415\u0414\u0415\u041D\u0418\u0415 \u0418 AI"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            type: "button",
                            className: `tab-btn ${activeTab === 'profile' ? 'active' : ''}`,
                            onClick: ()=>!isSaving && setActiveTab('profile'),
                            disabled: isSaving,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconImage), {
                                    size: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        "\u041F\u0420\u041E\u0424\u0418\u041B\u042C \u0418 \u0424\u041E\u0422\u041E (",
                                        formData.photos.length,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            type: "button",
                            className: `tab-btn ${activeTab === 'links' ? 'active' : ''}`,
                            onClick: ()=>!isSaving && setActiveTab('links'),
                            disabled: isSaving,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconLink), {
                                    size: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "\u041A\u041E\u041D\u0422\u0410\u041A\u0422\u042B \u0418 \u0421\u0421\u042B\u041B\u041A\u0418"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                    onSubmit: handleSubmit,
                    className: "modal-form",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                        disabled: isSaving,
                        style: {
                            border: 'none',
                            padding: 0,
                            margin: 0
                        },
                        children: [
                            activeTab === 'ai' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tab-pane",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0421\u0422\u0418\u041B\u042C \u041E\u0411\u0429\u0415\u041D\u0418\u042F (\u041F\u0420\u0415\u0421\u0415\u0422):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        name: "behaviorPreset",
                                                        value: formData.behaviorPreset,
                                                        onChange: handleChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                                                value: "support",
                                                                children: [
                                                                    "\u0418\u043D\u0436\u0435\u043D\u0435\u0440 \u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 PCHelp (",
                                                                    "{{agent_name}}",
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "business",
                                                                children: "\u0414\u0435\u043B\u043E\u0432\u0430\u044F (Business) \u2014 \u0444\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0442\u043E\u043D"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "friendly",
                                                                children: "\u0414\u0440\u0443\u0436\u0435\u043B\u044E\u0431\u043D\u0430\u044F (Friendly) \u2014 \u043C\u044F\u0433\u043A\u043E\u0435 \u043E\u0431\u0449\u0435\u043D\u0438\u0435"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "flirty",
                                                                children: "\u041A\u043E\u043A\u0435\u0442\u043B\u0438\u0432\u0430\u044F (Flirty) \u2014 \u043F\u043E\u0434\u043E\u0433\u0440\u0435\u0432 \u0438 \u0432\u043E\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "mysterious",
                                                                children: "\u0417\u0430\u0433\u0430\u0434\u043E\u0447\u043D\u0430\u044F (Mysterious) \u2014 \u0438\u043D\u0442\u0440\u0438\u0433\u0430 \u0438 \u043D\u0435\u0434\u043E\u0441\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u044C"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "custom",
                                                                children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 (Custom) \u2014 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u043F\u0442"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u041D\u0415\u0419\u0420\u041E\u0421\u0415\u0422\u0415\u0412\u0410\u042F \u041C\u041E\u0414\u0415\u041B\u042C (AI):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        name: "aiModel",
                                                        value: formData.aiModel,
                                                        onChange: handleChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gemini-3.5-flash",
                                                                children: "Gemini 3.5 Flash (\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gemini-3.5-flash-lite",
                                                                children: "Gemini 3.5 Flash Lite (\u0411\u044B\u0441\u0442\u0440\u0430\u044F / \u043D\u0438\u0437\u043A\u0430\u044F \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0430)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gemini-3.8-flash",
                                                                children: "Gemini 3.8 Flash"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gpt-4o-mini",
                                                                children: "GPT-4o Mini"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gpt-4o",
                                                                children: "GPT-4o"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                children: "\u041A\u041B\u042E\u0427 AI API (GEMINI / OPENAI API KEY):"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "password",
                                                name: "aiApiKey",
                                                placeholder: "AIzaSy... (\u0438\u043B\u0438 \u043E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043F\u0443\u0441\u0442\u044B\u043C \u0434\u043B\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u043E\u0433\u043E \u043A\u043B\u044E\u0447\u0430 \u0438\u0437 \u043E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u044F)",
                                                value: formData.aiApiKey,
                                                onChange: handleChange,
                                                autoComplete: "off"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "field-hint",
                                                children: "\u041A\u043B\u044E\u0447 Google AI Studio (Gemini) \u0434\u043B\u044F \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u0438 \u043E\u0442\u0432\u0435\u0442\u043E\u0432 \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u044C\u044E"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                children: [
                                                    "\u0418\u041C\u042F \u0418\u041D\u0416\u0415\u041D\u0415\u0420\u0410 / \u0421\u041F\u0415\u0426\u0418\u0410\u041B\u0418\u0421\u0422\u0410 (",
                                                    "{{agent_name}}",
                                                    "):"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "text",
                                                name: "agentName",
                                                placeholder: "\u0410\u043B\u0435\u043A\u0441\u0435\u0439",
                                                value: formData.agentName,
                                                onChange: handleChange
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "field-hint",
                                                children: [
                                                    "\u041F\u043E\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 ",
                                                    "{{agent_name}}",
                                                    " (\u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0438\u043C\u044F \u0431\u043E\u0442\u0430)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u041C\u0418\u041D. \u0417\u0410\u0414\u0415\u0420\u0416\u041A\u0410 \u041E\u0422\u0412\u0415\u0422\u0410 (\u0421\u0415\u041A):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "number",
                                                        name: "minDelay",
                                                        min: 1,
                                                        max: 60,
                                                        value: formData.minDelay,
                                                        onChange: handleChange
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0418\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043D\u0430\u0431\u043E\u0440\u0430 \u0442\u0435\u043A\u0441\u0442\u0430 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u043C"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u041C\u0410\u041A\u0421. \u0417\u0410\u0414\u0415\u0420\u0416\u041A\u0410 \u041E\u0422\u0412\u0415\u0422\u0410 (\u0421\u0415\u041A):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "number",
                                                        name: "maxDelay",
                                                        min: 2,
                                                        max: 120,
                                                        value: formData.maxDelay,
                                                        onChange: handleChange
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0412\u0435\u0440\u0445\u043D\u044F\u044F \u0433\u0440\u0430\u043D\u0438\u0446\u0430 \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u043E\u0439 \u043F\u0430\u0443\u0437\u044B"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "form-group",
                                        style: {
                                            marginBottom: '1.25rem'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "form-checkbox-card",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "checkbox",
                                                    name: "allowSilence",
                                                    checked: formData.allowSilence,
                                                    onChange: handleChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "form-checkbox-card-title",
                                                            children: "\u041F\u0420\u041E\u041C\u041E\u041B\u0427\u0410\u0422\u042C \u0412 \u041E\u0422\u0412\u0415\u0422, \u0415\u0421\u041B\u0418 \u0421\u041E\u041E\u0411\u0429\u0415\u041D\u0418\u0415 \u041D\u0415 \u0422\u0420\u0415\u0411\u0423\u0415\u0422 \u0420\u0415\u0410\u041A\u0426\u0418\u0418"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "form-checkbox-card-desc",
                                                            children: "\u0411\u043E\u0442 \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u0441\u043F\u0430\u043C\u0438\u0442\u044C \u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442 \u0440\u0435\u043F\u043B\u0438\u043A\u0443 \u043C\u043E\u043B\u0447\u0430\u043D\u0438\u0435\u043C, \u0435\u0441\u043B\u0438 \u0441\u043E\u0431\u0435\u0441\u0435\u0434\u043D\u0438\u043A \u043D\u0430\u043F\u0438\u0441\u0430\u043B \xab\u0421\u043F\u0430\u0441\u0438\u0431\u043E\xbb, \xab\u041E\u043A\xbb, \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u043B\u0441\u044F \u0438\u043B\u0438 \u0435\u0441\u043B\u0438 \u0434\u0438\u0430\u043B\u043E\u0433 \u0438\u0441\u0447\u0435\u0440\u043F\u0430\u043D."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd1ae8e317ad1e5f$export$bf898595ac5d35d5), {
                                        variables: formData.variables,
                                        onChange: (vars)=>setFormData((prev)=>({
                                                    ...prev,
                                                    variables: vars
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        style: {
                                            marginTop: '1.25rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                children: "\u0421\u0418\u0421\u0422\u0415\u041C\u041D\u042B\u0419 \u041F\u0420\u041E\u041C\u041F\u0422 \u0421 \u041F\u0415\u0420\u0415\u041C\u0415\u041D\u041D\u042B\u041C\u0418 \u0418 \u0412\u042B\u0417\u041E\u0412\u0410\u041C\u0418 \u0424\u0423\u041D\u041A\u0426\u0418\u0419:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $531450b6464cb467$export$24d1f7a2b509c3dc), {
                                                ref: promptEditorRef,
                                                value: formData.systemPrompt,
                                                onChange: (val)=>setFormData((prev)=>({
                                                            ...prev,
                                                            systemPrompt: val
                                                        })),
                                                variables: formData.variables,
                                                agentName: formData.agentName || formData.name,
                                                rows: 10,
                                                placeholder: "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043F\u0443\u0441\u0442\u044B\u043C \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E \u0448\u0430\u0431\u043B\u043E\u043D\u0430 \u043F\u0440\u0435\u0441\u0435\u0442\u0430..."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "field-hint",
                                                children: [
                                                    "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0441\u0432\u0435\u0442\u043A\u0430 \u0441\u0438\u043D\u0442\u0430\u043A\u0441\u0438\u0441\u0430, \u0432\u0441\u0442\u0430\u0432\u043A\u0430 \u0432 \u043F\u043E\u0437\u0438\u0446\u0438\u044E \u043A\u0443\u0440\u0441\u043E\u0440\u0430, \u0444\u0443\u043D\u043A\u0446\u0438\u0438 ",
                                                    '{{curl(url)}}',
                                                    " \u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u0440\u0438 \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043C\u044B\u0448\u0438 (XHR)."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeTab === 'profile' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tab-pane",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "section-label",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                children: "\u0424\u041E\u0422\u041E\u0410\u041B\u042C\u0411\u041E\u041C \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u0416\u0410:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0439\u0442\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0447\u0435\u0440\u0435\u0437 Ctrl+V, Drag & Drop \u0438\u043B\u0438 \u0441\u0441\u044B\u043B\u043A\u0438. \u041D\u0430\u0437\u043D\u0430\u0447\u044C\u0442\u0435 \u0433\u043B\u0430\u0432\u043D\u043E\u0435 \u0444\u043E\u0442\u043E \u0430\u0432\u0430\u0442\u0430\u0440\u043E\u043C."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e92e63ec1fda26be$export$ead625510f6b71f5), {
                                        photos: formData.photos,
                                        avatarUrl: formData.avatarUrl,
                                        onChangePhotos: (newPhotos, newAvatar)=>{
                                            setFormData((prev)=>({
                                                    ...prev,
                                                    photos: newPhotos,
                                                    avatarUrl: newAvatar
                                                }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        style: {
                                            marginTop: '1.25rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0418\u0414\u0415\u041D\u0422\u0418\u0424\u0418\u041A\u0410\u0422\u041E\u0420 \u0418\u041D\u0421\u0422\u0410\u041D\u0421\u0410 (ID):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "id",
                                                        value: formData.id,
                                                        onChange: handleChange,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 ID \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0438 Redis"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u041F\u041B\u0410\u0422\u0424\u041E\u0420\u041C\u0410:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                        name: "platform",
                                                        value: formData.platform,
                                                        onChange: handleChange,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "telegram",
                                                            children: "Telegram Web"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0418\u041C\u042F \u0411\u041E\u0422\u0410 (\u0412 TELEGRAM):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "name",
                                                        placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0410\u043D\u043D\u0430",
                                                        value: formData.name,
                                                        onChange: handleChange,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0441 \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u043C Telegram Web"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u042E\u0417\u0415\u0420\u041D\u0415\u0419\u041C \u0411\u041E\u0422\u0410 (@USERNAME):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "tgProfile",
                                                        placeholder: "@username",
                                                        value: formData.tgProfile,
                                                        onChange: handleChange,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0441 \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u043C Telegram Web"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0412\u041E\u0417\u0420\u0410\u0421\u0422:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "number",
                                                        name: "age",
                                                        min: 18,
                                                        max: 65,
                                                        value: formData.age,
                                                        onChange: handleChange,
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0421\u0422\u0420\u0410\u041D\u0410 / \u0413\u041E\u0420\u041E\u0414:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "country",
                                                        placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0410\u0440\u043C\u0435\u043D\u0438\u044F, \u0415\u0440\u0435\u0432\u0430\u043D",
                                                        value: formData.country,
                                                        onChange: handleChange,
                                                        required: true
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeTab === 'links' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tab-pane",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "TELEGRAM \u042E\u0417\u0415\u0420\u041D\u0415\u0419\u041C \u041F\u0420\u041E\u0424\u0418\u041B\u042F:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "tgProfile",
                                                        placeholder: "@username",
                                                        value: formData.tgProfile,
                                                        onChange: handleChange,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0432 Telegram Web"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "TELEGRAM \u041A\u041E\u041D\u0422\u0410\u041A\u0422\u041D\u0410\u042F \u0421\u0421\u042B\u041B\u041A\u0410 / \u041A\u0410\u041D\u0410\u041B:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "tlgLink",
                                                        placeholder: "@channel_or_link",
                                                        value: formData.tlgLink,
                                                        onChange: handleChange,
                                                        required: true
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                children: "\u0412\u0415\u0411-\u0421\u0421\u042B\u041B\u041A\u0410 (\u041F\u0410\u0420\u0422\u041D\u0415\u0420\u0421\u041A\u0410\u042F / \u0420\u0415\u0413\u0418\u0421\u0422\u0420\u0410\u0426\u0418\u042F):"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "url",
                                                name: "webLink",
                                                placeholder: "https://...",
                                                value: formData.webLink,
                                                onChange: handleChange,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "field-hint",
                                                children: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u0434\u0438\u0430\u043B\u043E\u0433\u0430\u0445 \u0434\u043B\u044F \u043A\u043E\u043D\u0432\u0435\u0440\u0441\u0438\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                children: "\u0421\u0421\u042B\u041B\u041A\u0410 \u041D\u0410 \u0412\u041D\u0415\u0428\u041D\u0418\u0415 \u041C\u0415\u0414\u0418\u0410 (\u041E\u0411\u041B\u0410\u041A\u041E):"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "url",
                                                name: "webMedia",
                                                placeholder: "https://drive.google.com/...",
                                                value: formData.webMedia,
                                                onChange: handleChange
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "field-hint",
                                                children: "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0444\u043E\u0442\u043E\u0430\u043B\u044C\u0431\u043E\u043C \u0431\u043E\u0442\u0430"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "modal-actions-footer",
                                children: [
                                    onCancel && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-secondary",
                                        onClick: onCancel,
                                        disabled: isSaving,
                                        children: "\u041E\u0422\u041C\u0415\u041D\u0410"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn-primary",
                                        disabled: isSaving,
                                        children: isSaving ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "btn-spinner"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\u0421\u041E\u0417\u0414\u0410\u041D\u0418\u0415..."
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconPlus), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\u0421\u041E\u0417\u0414\u0410\u0422\u042C \u0411\u041E\u0422\u0410"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $aZAsu = parcelRequire("aZAsu");
const $a22557d8003a0749$export$3c330c36ee2ee261 = ({ instance: instance, onSubmit: onSubmit, onCancel: onCancel })=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)('ai');
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const [saveStep, setSaveStep] = (0, $acw62.useState)(1);
    const [saveError, setSaveError] = (0, $acw62.useState)(null);
    const [isSuccess, setIsSuccess] = (0, $acw62.useState)(false);
    const existingPhotos = Array.isArray(instance.config.photos) && instance.config.photos.length > 0 ? instance.config.photos : instance.config.avatarUrl ? [
        instance.config.avatarUrl
    ] : [];
    const [formData, setFormData] = (0, $acw62.useState)({
        id: instance.id,
        platform: instance.platform || 'telegram',
        status: instance.status,
        name: instance.config.name || '',
        agentName: instance.config.agentName || instance.config.name || '',
        age: instance.config.age || 23,
        country: instance.config.country || '',
        avatarUrl: instance.config.avatarUrl || existingPhotos[0] || '',
        photos: existingPhotos,
        webLink: instance.config.webLink || '',
        webMedia: instance.config.webMedia || '',
        tgProfile: instance.config.tgProfile || '',
        tlgLink: instance.config.tlgLink || '',
        behaviorPreset: instance.config.behaviorPreset || 'flirty',
        systemPrompt: instance.config.systemPrompt || '',
        aiModel: instance.config.aiModel && !instance.config.aiModel.includes('2.') ? instance.config.aiModel : 'gemini-3.5-flash',
        aiApiKey: instance.config.aiApiKey || '',
        minDelay: instance.config.minDelay || 2,
        maxDelay: instance.config.maxDelay || 15,
        allowSilence: instance.config.allowSilence !== undefined ? instance.config.allowSilence : true,
        variables: instance.config.variables || {}
    });
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (isSaving) return;
        setIsSaving(true);
        setSaveError(null);
        setSaveStep(1);
        const stepTimer = setTimeout(()=>{
            setSaveStep(2);
        }, 700);
        try {
            await onSubmit(formData);
            clearTimeout(stepTimer);
            setSaveStep(3);
            setIsSuccess(true);
            setTimeout(()=>{
                onCancel();
            }, 700);
        } catch (err) {
            clearTimeout(stepTimer);
            setIsSaving(false);
            setSaveError(err?.message || "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0438 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0431\u043E\u0442\u0430");
        }
    };
    const handleChange = (e)=>{
        const { name: name, value: value, type: type } = e.target;
        setFormData((prev)=>({
                ...prev,
                [name]: type === 'checkbox' ? e.target.checked : type === 'number' ? Number(value) : value
            }));
    };
    const promptEditorRef = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-backdrop",
        onClick: (e)=>{
            if (e.target === e.currentTarget && !isSaving) onCancel();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "instance-modal",
            children: [
                isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "modal-progress-bar",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modal-progress-bar-inner"
                    })
                }),
                isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "modal-saving-overlay",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modal-saving-card",
                        children: [
                            isSuccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "saving-success-icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                    size: 24
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "saving-spinner-ring"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "modal-saving-title",
                                children: isSuccess ? "\u0418\u0417\u041C\u0415\u041D\u0415\u041D\u0418\u042F \u041F\u0420\u0418\u041C\u0415\u041D\u0415\u041D\u042B" : "\u0421\u0418\u041D\u0425\u0420\u041E\u041D\u0418\u0417\u0410\u0426\u0418\u042F \u041F\u0420\u041E\u0424\u0418\u041B\u042F"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "modal-saving-desc",
                                children: isSuccess ? "\u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F \u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u0431\u043E\u0442\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B \u0432 \u0431\u0430\u0437\u0435 \u0438 \u0432 \u0441\u0435\u0441\u0441\u0438\u0438." : instance.status === 'running' ? "\u041F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0432 Telegram Web..." : "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u043D\u043E\u0432\u044B\u0445 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0432 \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445..."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "modal-saving-steps",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `modal-saving-step ${saveStep >= 1 ? saveStep > 1 ? 'done' : 'active' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "step-icon",
                                                children: saveStep > 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                                    size: 12
                                                }) : "\u2022"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0432 \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445"
                                            })
                                        ]
                                    }),
                                    instance.status === 'running' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `modal-saving-step ${saveStep >= 2 ? saveStep > 2 ? 'done' : 'active' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "step-icon",
                                                children: saveStep > 2 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                                    size: 12
                                                }) : "\u2022"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0438\u043C\u0435\u043D\u0438 \u0438 \u044E\u0437\u0435\u0440\u043D\u0435\u0439\u043C\u0430 \u0432 Telegram Web"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `modal-saving-step ${saveStep >= 3 ? 'done' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "step-icon",
                                                children: saveStep >= 3 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                                    size: 12
                                                }) : "\u25CB"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-title-wrap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "modal-avatar-preview",
                                    children: formData.avatarUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: formData.avatarUrl,
                                        alt: formData.name,
                                        onError: (e)=>{
                                            e.target.style.display = 'none';
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: formData.name ? formData.name[0].toUpperCase() : 'B'
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "modal-title-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    children: "\u041A\u041E\u041D\u0424\u0418\u0413\u0423\u0420\u0410\u0426\u0418\u042F \u0411\u041E\u0422\u0410"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "modal-id-badge",
                                                    children: [
                                                        "ID: ",
                                                        formData.id
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "modal-subtitle",
                                            children: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043F\u0440\u043E\u0444\u0438\u043B\u044F, \u0434\u0438\u0430\u043B\u043E\u0433\u043E\u0432 \u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0445 \u043F\u0440\u043E\u043C\u043F\u0442\u043E\u0432"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            className: "close-btn",
                            disabled: isSaving,
                            onClick: ()=>!isSaving && onCancel(),
                            title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043A\u043D\u043E",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconClose), {
                                size: 16
                            })
                        })
                    ]
                }),
                saveError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "alert-box error",
                    style: {
                        margin: '1rem 1.5rem 0'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconAlert), {
                            size: 14
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: saveError
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: ()=>setSaveError(null),
                            className: "alert-close-btn",
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tabs-nav",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            type: "button",
                            className: `tab-btn ${activeTab === 'ai' ? 'active' : ''}`,
                            onClick: ()=>!isSaving && setActiveTab('ai'),
                            disabled: isSaving,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCpu), {
                                    size: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "\u041F\u041E\u0412\u0415\u0414\u0415\u041D\u0418\u0415 \u0418 AI"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            type: "button",
                            className: `tab-btn ${activeTab === 'profile' ? 'active' : ''}`,
                            onClick: ()=>!isSaving && setActiveTab('profile'),
                            disabled: isSaving,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconImage), {
                                    size: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        "\u041F\u0420\u041E\u0424\u0418\u041B\u042C \u0418 \u0424\u041E\u0422\u041E (",
                                        formData.photos.length,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            type: "button",
                            className: `tab-btn ${activeTab === 'links' ? 'active' : ''}`,
                            onClick: ()=>!isSaving && setActiveTab('links'),
                            disabled: isSaving,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconLink), {
                                    size: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "\u041A\u041E\u041D\u0422\u0410\u041A\u0422\u042B \u0418 \u0421\u0421\u042B\u041B\u041A\u0418"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                    onSubmit: handleSubmit,
                    className: "modal-form",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                        disabled: isSaving,
                        style: {
                            border: 'none',
                            padding: 0,
                            margin: 0
                        },
                        children: [
                            activeTab === 'ai' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tab-pane",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0421\u0422\u0418\u041B\u042C \u041E\u0411\u0429\u0415\u041D\u0418\u042F (\u041F\u0420\u0415\u0421\u0415\u0422):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        name: "behaviorPreset",
                                                        value: formData.behaviorPreset,
                                                        onChange: handleChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                                                value: "support",
                                                                children: [
                                                                    "\u0418\u043D\u0436\u0435\u043D\u0435\u0440 \u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 PCHelp (",
                                                                    "{{agent_name}}",
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "business",
                                                                children: "\u0414\u0435\u043B\u043E\u0432\u0430\u044F (Business) \u2014 \u0444\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0442\u043E\u043D"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "friendly",
                                                                children: "\u0414\u0440\u0443\u0436\u0435\u043B\u044E\u0431\u043D\u0430\u044F (Friendly) \u2014 \u043C\u044F\u0433\u043A\u043E\u0435 \u043E\u0431\u0449\u0435\u043D\u0438\u0435"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "flirty",
                                                                children: "\u041A\u043E\u043A\u0435\u0442\u043B\u0438\u0432\u0430\u044F (Flirty) \u2014 \u043F\u043E\u0434\u043E\u0433\u0440\u0435\u0432 \u0438 \u0432\u043E\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "mysterious",
                                                                children: "\u0417\u0430\u0433\u0430\u0434\u043E\u0447\u043D\u0430\u044F (Mysterious) \u2014 \u0438\u043D\u0442\u0440\u0438\u0433\u0430 \u0438 \u043D\u0435\u0434\u043E\u0441\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u044C"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "custom",
                                                                children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 (Custom) \u2014 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u043F\u0442"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u041D\u0415\u0419\u0420\u041E\u0421\u0415\u0422\u0415\u0412\u0410\u042F \u041C\u041E\u0414\u0415\u041B\u042C (AI):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        name: "aiModel",
                                                        value: formData.aiModel,
                                                        onChange: handleChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gemini-3.5-flash",
                                                                children: "Gemini 3.5 Flash (\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gemini-3.5-flash-lite",
                                                                children: "Gemini 3.5 Flash Lite (\u0411\u044B\u0441\u0442\u0440\u0430\u044F / \u043D\u0438\u0437\u043A\u0430\u044F \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0430)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gemini-3.8-flash",
                                                                children: "Gemini 3.8 Flash"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gpt-4o-mini",
                                                                children: "GPT-4o Mini"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "gpt-4o",
                                                                children: "GPT-4o (\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                children: "\u041A\u041B\u042E\u0427 AI API (GEMINI / OPENAI API KEY):"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "password",
                                                name: "aiApiKey",
                                                placeholder: "AIzaSy... (\u0438\u043B\u0438 \u043E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043F\u0443\u0441\u0442\u044B\u043C \u0434\u043B\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u043E\u0433\u043E \u043A\u043B\u044E\u0447\u0430 \u0438\u0437 \u043E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u044F)",
                                                value: formData.aiApiKey,
                                                onChange: handleChange,
                                                autoComplete: "off"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "field-hint",
                                                children: "\u041A\u043B\u044E\u0447 Google AI Studio (Gemini) \u0434\u043B\u044F \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u0438 \u043E\u0442\u0432\u0435\u0442\u043E\u0432 \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u044C\u044E"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                children: [
                                                    "\u0418\u041C\u042F \u0418\u041D\u0416\u0415\u041D\u0415\u0420\u0410 / \u0421\u041F\u0415\u0426\u0418\u0410\u041B\u0418\u0421\u0422\u0410 (",
                                                    "{{agent_name}}",
                                                    "):"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "text",
                                                name: "agentName",
                                                placeholder: "\u0410\u043B\u0435\u043A\u0441\u0435\u0439",
                                                value: formData.agentName,
                                                onChange: handleChange
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "field-hint",
                                                children: [
                                                    "\u041F\u043E\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 ",
                                                    "{{agent_name}}",
                                                    " (\u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0438\u043C\u044F \u0431\u043E\u0442\u0430)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u041C\u0418\u041D. \u0417\u0410\u0414\u0415\u0420\u0416\u041A\u0410 \u041E\u0422\u0412\u0415\u0422\u0410 (\u0421\u0415\u041A):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "number",
                                                        name: "minDelay",
                                                        min: 1,
                                                        max: 60,
                                                        value: formData.minDelay,
                                                        onChange: handleChange
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0418\u043C\u0438\u0442\u0430\u0446\u0438\u044F \u043D\u0430\u0431\u043E\u0440\u0430 \u0442\u0435\u043A\u0441\u0442\u0430 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u043C"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u041C\u0410\u041A\u0421. \u0417\u0410\u0414\u0415\u0420\u0416\u041A\u0410 \u041E\u0422\u0412\u0415\u0422\u0410 (\u0421\u0415\u041A):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "number",
                                                        name: "maxDelay",
                                                        min: 2,
                                                        max: 120,
                                                        value: formData.maxDelay,
                                                        onChange: handleChange
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0412\u0435\u0440\u0445\u043D\u044F\u044F \u0433\u0440\u0430\u043D\u0438\u0446\u0430 \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u043E\u0439 \u043F\u0430\u0443\u0437\u044B"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "form-group",
                                        style: {
                                            marginBottom: '1.25rem'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "form-checkbox-card",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "checkbox",
                                                    name: "allowSilence",
                                                    checked: formData.allowSilence,
                                                    onChange: handleChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "form-checkbox-card-title",
                                                            children: "\u041F\u0420\u041E\u041C\u041E\u041B\u0427\u0410\u0422\u042C \u0412 \u041E\u0422\u0412\u0415\u0422, \u0415\u0421\u041B\u0418 \u0421\u041E\u041E\u0411\u0429\u0415\u041D\u0418\u0415 \u041D\u0415 \u0422\u0420\u0415\u0411\u0423\u0415\u0422 \u0420\u0415\u0410\u041A\u0426\u0418\u0418"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "form-checkbox-card-desc",
                                                            children: "\u0411\u043E\u0442 \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u0441\u043F\u0430\u043C\u0438\u0442\u044C \u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442 \u0440\u0435\u043F\u043B\u0438\u043A\u0443 \u043C\u043E\u043B\u0447\u0430\u043D\u0438\u0435\u043C, \u0435\u0441\u043B\u0438 \u0441\u043E\u0431\u0435\u0441\u0435\u0434\u043D\u0438\u043A \u043D\u0430\u043F\u0438\u0441\u0430\u043B \xab\u0421\u043F\u0430\u0441\u0438\u0431\u043E\xbb, \xab\u041E\u043A\xbb, \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u043B\u0441\u044F \u0438\u043B\u0438 \u0435\u0441\u043B\u0438 \u0434\u0438\u0430\u043B\u043E\u0433 \u0438\u0441\u0447\u0435\u0440\u043F\u0430\u043D."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd1ae8e317ad1e5f$export$bf898595ac5d35d5), {
                                        variables: formData.variables,
                                        onChange: (vars)=>setFormData((prev)=>({
                                                    ...prev,
                                                    variables: vars
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        style: {
                                            marginTop: '1.25rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                children: "\u0421\u0418\u0421\u0422\u0415\u041C\u041D\u042B\u0419 \u041F\u0420\u041E\u041C\u041F\u0422 \u0421 \u041F\u0415\u0420\u0415\u041C\u0415\u041D\u041D\u042B\u041C\u0418 \u0418 \u0412\u042B\u0417\u041E\u0412\u0410\u041C\u0418 \u0424\u0423\u041D\u041A\u0426\u0418\u0419:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $531450b6464cb467$export$24d1f7a2b509c3dc), {
                                                ref: promptEditorRef,
                                                value: formData.systemPrompt,
                                                onChange: (val)=>setFormData((prev)=>({
                                                            ...prev,
                                                            systemPrompt: val
                                                        })),
                                                variables: formData.variables,
                                                agentName: formData.agentName || formData.name,
                                                rows: 10,
                                                placeholder: "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043F\u0443\u0441\u0442\u044B\u043C \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E \u0448\u0430\u0431\u043B\u043E\u043D\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u044B..."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "field-hint",
                                                children: [
                                                    "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0441\u0432\u0435\u0442\u043A\u0430 \u0441\u0438\u043D\u0442\u0430\u043A\u0441\u0438\u0441\u0430, \u0432\u0441\u0442\u0430\u0432\u043A\u0430 \u0432 \u043F\u043E\u0437\u0438\u0446\u0438\u044E \u043A\u0443\u0440\u0441\u043E\u0440\u0430, \u0444\u0443\u043D\u043A\u0446\u0438\u0438 ",
                                                    '{{curl(url)}}',
                                                    " \u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u0440\u0438 \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043C\u044B\u0448\u0438 (XHR)."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeTab === 'profile' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tab-pane",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "section-label",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                children: "\u0424\u041E\u0422\u041E\u0410\u041B\u042C\u0411\u041E\u041C \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u0416\u0410:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0439\u0442\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0447\u0435\u0440\u0435\u0437 Ctrl+V, Drag & Drop \u0438\u043B\u0438 \u0441\u0441\u044B\u043B\u043A\u0438. \u041D\u0430\u0437\u043D\u0430\u0447\u044C\u0442\u0435 \u0433\u043B\u0430\u0432\u043D\u043E\u0435 \u0444\u043E\u0442\u043E \u0430\u0432\u0430\u0442\u0430\u0440\u043E\u043C."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e92e63ec1fda26be$export$ead625510f6b71f5), {
                                        photos: formData.photos,
                                        avatarUrl: formData.avatarUrl,
                                        onChangePhotos: (newPhotos, newAvatar)=>{
                                            setFormData((prev)=>({
                                                    ...prev,
                                                    photos: newPhotos,
                                                    avatarUrl: newAvatar
                                                }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        style: {
                                            marginTop: '1.25rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0418\u041C\u042F \u0411\u041E\u0422\u0410 (\u0412 TELEGRAM):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "name",
                                                        value: formData.name,
                                                        onChange: handleChange,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u0432 \u0448\u0430\u043F\u043A\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u042E\u0417\u0415\u0420\u041D\u0415\u0419\u041C \u0411\u041E\u0422\u0410 (@USERNAME):"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "tgProfile",
                                                        placeholder: "@username",
                                                        value: formData.tgProfile,
                                                        onChange: handleChange,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0441 Telegram Web"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0412\u041E\u0417\u0420\u0410\u0421\u0422:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "number",
                                                        name: "age",
                                                        min: 18,
                                                        max: 65,
                                                        value: formData.age,
                                                        onChange: handleChange,
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u0421\u0422\u0420\u0410\u041D\u0410 / \u0413\u041E\u0420\u041E\u0414:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "country",
                                                        value: formData.country,
                                                        onChange: handleChange,
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "\u041F\u041B\u0410\u0422\u0424\u041E\u0420\u041C\u0410:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                        name: "platform",
                                                        value: formData.platform,
                                                        onChange: handleChange,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "telegram",
                                                            children: "Telegram Web"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeTab === 'links' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tab-pane",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-row-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "TELEGRAM \u042E\u0417\u0415\u0420\u041D\u0415\u0419\u041C \u041F\u0420\u041E\u0424\u0418\u041B\u042F:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "tgProfile",
                                                        placeholder: "@username",
                                                        value: formData.tgProfile,
                                                        onChange: handleChange,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "field-hint",
                                                        children: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0441 \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u043C Telegram Web"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        children: "TELEGRAM \u041A\u041E\u041D\u0422\u0410\u041A\u0422\u041D\u0410\u042F \u0421\u0421\u042B\u041B\u041A\u0410 / \u041A\u0410\u041D\u0410\u041B:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "tlgLink",
                                                        placeholder: "@channel_or_link",
                                                        value: formData.tlgLink,
                                                        onChange: handleChange,
                                                        required: true
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                children: "\u0412\u0415\u0411-\u0421\u0421\u042B\u041B\u041A\u0410 (\u041F\u0410\u0420\u0422\u041D\u0415\u0420\u0421\u041A\u0410\u042F / \u0420\u0415\u0413\u0418\u0421\u0422\u0420\u0410\u0426\u0418\u042F):"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "url",
                                                name: "webLink",
                                                value: formData.webLink,
                                                onChange: handleChange,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "field-hint",
                                                children: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0432 \u0447\u0430\u0442\u0435 \u043F\u0440\u0438 \u043A\u043E\u043D\u0432\u0435\u0440\u0441\u0438\u0438"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                children: "\u0421\u0421\u042B\u041B\u041A\u0410 \u041D\u0410 \u0412\u041D\u0415\u0428\u041D\u0418\u0415 \u041C\u0415\u0414\u0418\u0410 (\u041E\u0411\u041B\u0410\u041A\u041E / \u0410\u041B\u042C\u0411\u041E\u041C):"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "url",
                                                name: "webMedia",
                                                value: formData.webMedia,
                                                onChange: handleChange
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "field-hint",
                                                children: "\u0412\u043D\u0435\u0448\u043D\u0438\u0439 \u0444\u043E\u0442\u043E\u0430\u043B\u044C\u0431\u043E\u043C (\u0435\u0441\u043B\u0438 \u043D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u0444\u043E\u0442\u043E)"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "modal-actions-footer",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-secondary",
                                        onClick: onCancel,
                                        disabled: isSaving,
                                        children: "\u041E\u0422\u041C\u0415\u041D\u0410"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn-primary",
                                        disabled: isSaving,
                                        children: isSaving ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "btn-spinner"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\u041F\u0420\u0418\u041C\u0415\u041D\u0415\u041D\u0418\u0415..."
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\u0421\u041E\u0425\u0420\u0410\u041D\u0418\u0422\u042C \u0418\u0417\u041C\u0415\u041D\u0415\u041D\u0418\u042F"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $cxNgw = parcelRequire("cxNgw");

var $aZAsu = parcelRequire("aZAsu");
const $c6de12348ffb204f$export$9aed520f056d3641 = ({ instanceId: instanceId, instanceName: instanceName, isRunning: isRunning, onClose: onClose })=>{
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [imageData, setImageData] = (0, $acw62.useState)(null);
    const [pageUrl, setPageUrl] = (0, $acw62.useState)(null);
    const [pageTitle, setPageTitle] = (0, $acw62.useState)(null);
    const [lastUpdated, setLastUpdated] = (0, $acw62.useState)(null);
    const [autoRefresh, setAutoRefresh] = (0, $acw62.useState)(false);
    const [downloadSuccess, setDownloadSuccess] = (0, $acw62.useState)(false);
    const autoRefreshTimerRef = (0, $acw62.useRef)(null);
    const fetchScreenshot = (0, $acw62.useCallback)(async (isBackground = false)=>{
        if (!isBackground) setLoading(true);
        setError(null);
        try {
            const token = (0, $cxNgw.authService).getAuthToken();
            const res = await fetch(`/api/instances/${instanceId}/screenshot`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!res.ok) {
                const data = await res.json().catch(()=>({}));
                throw new Error(data.error || `HTTP ${res.status}: \u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{43F}\u{440}\u{438} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{438} \u{441}\u{43A}\u{440}\u{438}\u{43D}\u{448}\u{43E}\u{442}\u{430}`);
            }
            const data = await res.json();
            setImageData(data.image);
            setPageUrl(data.url || null);
            setPageTitle(data.title || null);
            setLastUpdated(new Date(data.timestamp || Date.now()));
        } catch (err) {
            console.error('Screenshot fetch failed:', err);
            setError(err.message || "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u043D\u0438\u043C\u043E\u043A \u044D\u043A\u0440\u0430\u043D\u0430");
        } finally{
            if (!isBackground) setLoading(false);
        }
    }, [
        instanceId
    ]);
    // Загрузка скриншота при открытии
    (0, $acw62.useEffect)(()=>{
        fetchScreenshot();
    }, [
        fetchScreenshot
    ]);
    // Обработка автообновления
    (0, $acw62.useEffect)(()=>{
        if (autoRefresh && isRunning) autoRefreshTimerRef.current = setInterval(()=>{
            fetchScreenshot(true);
        }, 3000);
        else if (autoRefreshTimerRef.current) {
            clearInterval(autoRefreshTimerRef.current);
            autoRefreshTimerRef.current = null;
        }
        return ()=>{
            if (autoRefreshTimerRef.current) clearInterval(autoRefreshTimerRef.current);
        };
    }, [
        autoRefresh,
        isRunning,
        fetchScreenshot
    ]);
    const handleDownload = ()=>{
        if (!imageData) return;
        try {
            const a = document.createElement('a');
            a.href = imageData;
            const cleanName = (instanceName || instanceId).replace(/[^a-zA-Z0-9а-яА-Я_-]/g, '_');
            a.download = `screenshot_${cleanName}_${Date.now()}.jpg`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setDownloadSuccess(true);
            setTimeout(()=>setDownloadSuccess(false), 2000);
        } catch (err) {
            console.error('Failed to download image:', err);
        }
    };
    const formattedTime = lastUpdated ? lastUpdated.toLocaleTimeString('ru-RU', {
        hour12: false
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-backdrop",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "instance-modal screenshot-modal",
            onClick: (e)=>e.stopPropagation(),
            style: {
                maxWidth: '1080px',
                width: '95%'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-title-wrap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bot-avatar-frame",
                                    style: {
                                        width: '38px',
                                        height: '38px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCamera), {
                                        size: 20
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "modal-title-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            children: [
                                                "\u0411\u0420\u0410\u0423\u0417\u0415\u0420: ",
                                                instanceName.toUpperCase() || "\u0418\u041D\u0421\u0422\u0410\u041D\u0421"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "modal-id-badge",
                                            children: [
                                                "ID: ",
                                                instanceId
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: `status-badge ${isRunning ? 'running' : 'stopped'}`,
                                            style: {
                                                marginLeft: '8px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "status-dot"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "status-text",
                                                    children: isRunning ? "\u041E\u041D\u041B\u0410\u0419\u041D" : "\u041E\u0421\u0422\u0410\u041D\u041E\u0412\u041B\u0415\u041D"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            className: "btn-modal-close",
                            onClick: onClose,
                            title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconClose), {
                                size: 18
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "screenshot-browser-toolbar",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "browser-url-pill",
                            title: pageUrl || "URL \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "url-protocol",
                                    children: "https://"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "url-text",
                                    children: pageUrl ? pageUrl.replace(/^https?:\/\//, '') : 'web.telegram.org/k/'
                                }),
                                pageTitle && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "page-title-badge",
                                    title: pageTitle,
                                    children: pageTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "screenshot-toolbar-actions",
                            children: [
                                formattedTime && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "screenshot-timestamp",
                                    title: "\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0441\u043D\u0438\u043C\u043A\u0430",
                                    children: [
                                        "\u0421\u041D\u0418\u041C\u041E\u041A: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: formattedTime
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "screenshot-auto-refresh-toggle",
                                    title: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u043A\u0440\u0438\u043D\u0448\u043E\u0442\u0430 \u043A\u0430\u0436\u0434\u044B\u0435 3 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            checked: autoRefresh,
                                            onChange: (e)=>setAutoRefresh(e.target.checked),
                                            disabled: !isRunning
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "toggle-label",
                                            children: "\u0410\u0412\u0422\u041E (3\u0421)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    className: "btn btn-secondary btn-sm",
                                    onClick: ()=>fetchScreenshot(),
                                    disabled: loading,
                                    title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u043A\u0440\u0438\u043D\u0448\u043E\u0442 \u0441\u0435\u0439\u0447\u0430\u0441",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconRefresh), {
                                            size: 13,
                                            className: loading ? 'icon-spin' : ''
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: loading ? "\u0421\u041D\u0418\u041C\u0410\u0415\u041C..." : "\u041E\u0411\u041D\u041E\u0412\u0418\u0422\u042C"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    className: `btn btn-sm ${downloadSuccess ? 'btn-success' : 'btn-outline'}`,
                                    onClick: handleDownload,
                                    disabled: !imageData,
                                    title: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0441\u043A\u0440\u0438\u043D\u0448\u043E\u0442 \u0432 JPG",
                                    children: [
                                        downloadSuccess ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCheck), {
                                            size: 13
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconDownload), {
                                            size: 13
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: downloadSuccess ? "\u0421\u041E\u0425\u0420\u0410\u041D\u0415\u041D\u041E" : "\u0421\u041A\u0410\u0427\u0410\u0422\u042C"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "screenshot-viewport-container",
                    children: [
                        loading && !imageData && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "screenshot-loading-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "spinner"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "\u041F\u041E\u0414\u041A\u041B\u042E\u0427\u0415\u041D\u0418\u0415 \u041A \u0411\u0420\u0410\u0423\u0417\u0415\u0420\u0423 \u0418 \u0421\u041E\u0417\u0414\u0410\u041D\u0418\u0415 \u0421\u041D\u0418\u041C\u041A\u0410..."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "sub-hint",
                                    children: "Puppeteer \u0434\u0435\u043B\u0430\u0435\u0442 \u0437\u0430\u0445\u0432\u0430\u0442 \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u0438\u0441\u043F\u043B\u0435\u044F"
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "screenshot-error-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconAlert), {
                                    size: 28
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "\u041E\u0428\u0418\u0411\u041A\u0410 \u041F\u041E\u041B\u0423\u0427\u0415\u041D\u0418\u042F \u0421\u041A\u0420\u0418\u041D\u0428\u041E\u0422\u0410"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: error
                                }),
                                !isRunning && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "error-tip",
                                    children: [
                                        "\u0411\u043E\u0442 \u0432 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D. \u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0431\u043E\u0442\u0430 \u043A\u043D\u043E\u043F\u043A\u043E\u0439 ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "\xab\u0417\u0410\u041F\u0423\u0421\u0422\u0418\u0422\u042C\xbb"
                                        }),
                                        " \u0432 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-primary btn-sm",
                                    onClick: ()=>fetchScreenshot(),
                                    children: "\u041F\u041E\u0412\u0422\u041E\u0420\u0418\u0422\u042C \u041F\u041E\u041F\u042B\u0422\u041A\u0423"
                                })
                            ]
                        }),
                        !error && imageData && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "screenshot-image-frame",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: imageData,
                                alt: `\u{421}\u{43A}\u{440}\u{438}\u{43D}\u{448}\u{43E}\u{442} \u{431}\u{440}\u{430}\u{443}\u{437}\u{435}\u{440}\u{430} ${instanceName || instanceId}`,
                                className: "screenshot-img"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "screenshot-footer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "screenshot-footer-info",
                            children: "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u044D\u043A\u0440\u0430\u043D\u0430: 1920\xd71080 | \u0424\u043E\u0440\u043C\u0430\u0442: JPEG | \u0414\u0438\u0441\u043F\u043B\u0435\u0439: :99"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            className: "btn btn-secondary",
                            onClick: onClose,
                            children: "\u0417\u0410\u041A\u0420\u042B\u0422\u042C"
                        })
                    ]
                })
            ]
        })
    });
};



var $cxNgw = parcelRequire("cxNgw");

var $aZAsu = parcelRequire("aZAsu");
const $ebab744a88129edc$var$API_BASE_URL = '';
const $ebab744a88129edc$export$2e18f541b3e93e = ()=>{
    const [instances, setInstances] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [showCreateForm, setShowCreateForm] = (0, $acw62.useState)(false);
    const [editingInstance, setEditingInstance] = (0, $acw62.useState)(null);
    const [screenshotInstance, setScreenshotInstance] = (0, $acw62.useState)(null);
    const [actionLoading, setActionLoading] = (0, $acw62.useState)(null);
    const [expandedInstanceId, setExpandedInstanceId] = (0, $acw62.useState)(null);
    // Поиск и фильтрация
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)('');
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)('all');
    (0, $acw62.useEffect)(()=>{
        fetchInstances();
        const interval = setInterval(fetchInstances, 5000);
        return ()=>clearInterval(interval);
    }, []);
    const fetchInstances = async ()=>{
        try {
            setError(null);
            const token = (0, $cxNgw.authService).getAuthToken();
            const response = await fetch(`${$ebab744a88129edc$var$API_BASE_URL}/api/instances`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error(`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{430}: ${response.status}`);
            const data = await response.json();
            if (!Array.isArray(data)) throw new Error("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0442 \u0441\u0435\u0440\u0432\u0435\u0440\u0430");
            setInstances(data);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
            console.error('failed to fetch instances:', err);
            setError(`\u{41D}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{438}\u{442}\u{44C} \u{441}\u{43F}\u{438}\u{441}\u{43E}\u{43A} \u{431}\u{43E}\u{442}\u{43E}\u{432}: ${errorMessage}`);
            setInstances([]);
        } finally{
            setLoading(false);
        }
    };
    const handleCreateInstance = async (data)=>{
        try {
            setError(null);
            const token = (0, $cxNgw.authService).getAuthToken();
            const response = await fetch(`${$ebab744a88129edc$var$API_BASE_URL}/api/instances`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                const errorData = await response.json().catch(()=>({}));
                throw new Error(errorData.error || "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0431\u043E\u0442\u0430");
            }
            await fetchInstances();
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
            setError(`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{44F}: ${errorMessage}`);
            throw err;
        }
    };
    const handleStart = async (id)=>{
        try {
            setActionLoading(id);
            setError(null);
            const token = (0, $cxNgw.authService).getAuthToken();
            const response = await fetch(`${$ebab744a88129edc$var$API_BASE_URL}/api/instances/${id}/start`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(()=>({}));
                throw new Error(errorData.error || "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u043F\u0443\u0441\u043A\u0435 \u0438\u043D\u0441\u0442\u0430\u043D\u0441\u0430");
            }
            await fetchInstances();
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
            setError(`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{437}\u{430}\u{43F}\u{443}\u{441}\u{43A}\u{430} \u{431}\u{43E}\u{442}\u{430} [${id}]: ${errorMessage}`);
        } finally{
            setActionLoading(null);
        }
    };
    const handleStop = async (id)=>{
        try {
            setActionLoading(id);
            setError(null);
            const token = (0, $cxNgw.authService).getAuthToken();
            const response = await fetch(`${$ebab744a88129edc$var$API_BASE_URL}/api/instances/${id}/stop`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(()=>({}));
                throw new Error(errorData.error || "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0435 \u0438\u043D\u0441\u0442\u0430\u043D\u0441\u0430");
            }
            await fetchInstances();
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
            setError(`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{438} \u{431}\u{43E}\u{442}\u{430} [${id}]: ${errorMessage}`);
        } finally{
            setActionLoading(null);
        }
    };
    const handleUpdate = async (data)=>{
        try {
            setError(null);
            const token = (0, $cxNgw.authService).getAuthToken();
            const response = await fetch(`${$ebab744a88129edc$var$API_BASE_URL}/api/instances/${data.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                const errorData = await response.json().catch(()=>({}));
                throw new Error(errorData.error || "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0431\u043E\u0442\u0430");
            }
            await fetchInstances();
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
            setError(`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}: ${errorMessage}`);
            throw err;
        }
    };
    const handleDelete = async (id, name)=>{
        if (!window.confirm(`\u{41F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{434}\u{438}\u{442}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{431}\u{43E}\u{442}\u{430} "${name || id}"? \u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{43D}\u{435}\u{43E}\u{431}\u{440}\u{430}\u{442}\u{438}\u{43C}\u{43E}.`)) return;
        try {
            setError(null);
            const token = (0, $cxNgw.authService).getAuthToken();
            const response = await fetch(`${$ebab744a88129edc$var$API_BASE_URL}/api/instances/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F");
            }
            await fetchInstances();
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430";
            setError(`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{438}\u{44F}: ${errorMessage}`);
        }
    };
    const toggleExpand = (id)=>{
        setExpandedInstanceId((prev)=>prev === id ? null : id);
    };
    const runningCount = instances.filter((i)=>i.status === 'running').length;
    const stoppedCount = instances.filter((i)=>i.status === 'stopped').length;
    const aiErrorCount = instances.filter((i)=>Boolean(i.lastError)).length;
    const filteredInstances = (0, $acw62.useMemo)(()=>{
        return instances.filter((inst)=>{
            // Фильтр по статусу
            if (statusFilter !== 'all' && inst.status !== statusFilter) return false;
            // Фильтр по поиску
            if (searchQuery.trim()) {
                const q = searchQuery.toLowerCase().trim();
                const idMatch = inst.id.toLowerCase().includes(q);
                const nameMatch = (inst.config?.name || '').toLowerCase().includes(q);
                const tgMatch = (inst.config?.tgProfile || '').toLowerCase().includes(q);
                const countryMatch = (inst.config?.country || '').toLowerCase().includes(q);
                return idMatch || nameMatch || tgMatch || countryMatch;
            }
            return true;
        });
    }, [
        instances,
        statusFilter,
        searchQuery
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "instances-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "dashboard-stats-bar",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stats-group",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat-label",
                                        children: "\u0412\u0421\u0415\u0413\u041E \u0418\u041D\u0421\u0422\u0410\u041D\u0421\u041E\u0412"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat-val",
                                        children: instances.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat-card stat-success",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat-label",
                                        children: "\u0410\u041A\u0422\u0418\u0412\u041D\u042B\u0425 \u0411\u041E\u0422\u041E\u0412"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat-val",
                                        children: runningCount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat-card stat-muted",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat-label",
                                        children: "\u041E\u0421\u0422\u0410\u041D\u041E\u0412\u041B\u0415\u041D\u041E"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat-val",
                                        children: stoppedCount
                                    })
                                ]
                            }),
                            aiErrorCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat-card stat-error",
                                title: "\u0411\u043E\u0442\u044B \u0441 \u043E\u0448\u0438\u0431\u043A\u0430\u043C\u0438 \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u0438 \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u0438",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat-label",
                                        children: "\u0421\u0411\u041E\u0418 AI"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat-val",
                                        children: aiErrorCount
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stats-actions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: "btn btn-primary",
                                onClick: ()=>setShowCreateForm(true),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconPlus), {
                                        size: 14
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "\u0421\u041E\u0417\u0414\u0410\u0422\u042C \u0411\u041E\u0422\u0410"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "btn btn-secondary btn-icon-only",
                                onClick: fetchInstances,
                                title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u0441 \u0441\u0435\u0440\u0432\u0435\u0440\u0430",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconRefresh), {
                                    size: 14
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "dashboard-filter-bar",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "search-input-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconSearch), {
                                size: 14,
                                className: "search-icon"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                className: "search-field",
                                placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438, ID, \u044E\u0437\u0435\u0440\u043D\u0435\u0439\u043C\u0443 \u0438\u043B\u0438 \u043B\u043E\u043A\u0430\u0446\u0438\u0438...",
                                value: searchQuery,
                                onChange: (e)=>setSearchQuery(e.target.value)
                            }),
                            searchQuery && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "search-clear-btn",
                                onClick: ()=>setSearchQuery(''),
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "filter-tabs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: `filter-tab ${statusFilter === 'all' ? 'active' : ''}`,
                                onClick: ()=>setStatusFilter('all'),
                                children: [
                                    "\u0412\u0421\u0415 (",
                                    instances.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: `filter-tab ${statusFilter === 'running' ? 'active' : ''}`,
                                onClick: ()=>setStatusFilter('running'),
                                children: [
                                    "\u0410\u041A\u0422\u0418\u0412\u041D\u042B\u0415 (",
                                    runningCount,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: `filter-tab ${statusFilter === 'stopped' ? 'active' : ''}`,
                                onClick: ()=>setStatusFilter('stopped'),
                                children: [
                                    "\u041E\u0421\u0422\u0410\u041D\u041E\u0412\u041B\u0415\u041D\u041D\u042B\u0415 (",
                                    stoppedCount,
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            aiErrorCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "dashboard-global-ai-warning",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "ai-warning-icon-wrap",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconAlert), {
                            size: 20
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "ai-warning-text-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                children: [
                                    "\u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435! \u0423 ",
                                    aiErrorCount,
                                    " ",
                                    aiErrorCount === 1 ? "\u0431\u043E\u0442\u0430" : "\u0431\u043E\u0442\u043E\u0432",
                                    " \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u0451\u043B \u0441\u0431\u043E\u0439 \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u0435\u0437 AI."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "\u0424\u043E\u043B\u0431\u044D\u043A-\u043F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u2014 \u0431\u043E\u0442 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 \u043B\u043E\u0436\u043D\u044B\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0430\u043B\u0438\u0434\u043D\u043E\u0441\u0442\u044C API-\u043A\u043B\u044E\u0447\u0430 \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u0438 \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0431\u043E\u0442\u0430."
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "alert-box error",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconAlert), {
                        size: 14
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>setError(null),
                        className: "alert-close-btn",
                        children: "\xd7"
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "loading-state",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "spinner"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "\u0421\u0418\u041D\u0425\u0420\u041E\u041D\u0418\u0417\u0410\u0426\u0418\u042F \u0421\u0415\u0420\u0412\u0415\u0420\u0410..."
                    })
                ]
            }) : filteredInstances.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "empty-state-box",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "empty-icon-mark",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconTerminal), {
                            size: 28
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "\u0418\u041D\u0421\u0422\u0410\u041D\u0421\u042B \u041D\u0415 \u041D\u0410\u0419\u0414\u0415\u041D\u042B"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: instances.length === 0 ? "\u0412 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u043D\u0435\u0442 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0431\u043E\u0442\u043E\u0432. \u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u0443\u044E \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044E \u0434\u043B\u044F \u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B." : "\u041D\u0435\u0442 \u0431\u043E\u0442\u043E\u0432, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C \u043F\u043E\u0438\u0441\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0438\u043B\u0438 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0444\u0438\u043B\u044C\u0442\u0440\u0430."
                    }),
                    instances.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        className: "btn btn-primary",
                        onClick: ()=>setShowCreateForm(true),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconPlus), {
                                size: 14
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "\u0421\u041E\u0417\u0414\u0410\u0422\u042C \u041F\u0415\u0420\u0412\u041E\u0413\u041E \u0411\u041E\u0422\u0410"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "btn btn-secondary",
                        onClick: ()=>{
                            setSearchQuery('');
                            setStatusFilter('all');
                        },
                        children: "\u0421\u0411\u0420\u041E\u0421\u0418\u0422\u042C \u0424\u0418\u041B\u042C\u0422\u0420\u042B"
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "instances-grid",
                children: filteredInstances.map((inst)=>{
                    const isExpanded = expandedInstanceId === inst.id;
                    const isProcessing = actionLoading === inst.id;
                    const cfg = inst.config || {};
                    const age = cfg.age || 23;
                    const presetLabel = cfg.behaviorPreset === 'friendly' ? "\u0414\u0440\u0443\u0436\u0435\u043B\u044E\u0431\u043D\u0430\u044F" : cfg.behaviorPreset === 'business' ? "\u0414\u0435\u043B\u043E\u0432\u0430\u044F" : cfg.behaviorPreset === 'mysterious' ? "\u0417\u0430\u0433\u0430\u0434\u043E\u0447\u043D\u0430\u044F" : cfg.behaviorPreset === 'custom' ? "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439" : "\u041A\u043E\u043A\u0435\u0442\u043B\u0438\u0432\u0430\u044F (Flirty)";
                    const photosList = Array.isArray(cfg.photos) && cfg.photos.length > 0 ? cfg.photos : cfg.avatarUrl ? [
                        cfg.avatarUrl
                    ] : [];
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `instance-card status-${inst.status}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "instance-card-header",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bot-profile-chip",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "bot-avatar-frame",
                                                children: cfg.avatarUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: cfg.avatarUrl,
                                                    alt: cfg.name || inst.id,
                                                    onError: (e)=>{
                                                        e.target.style.display = 'none';
                                                    }
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "bot-avatar-fallback",
                                                    children: (cfg.name || inst.id)[0].toUpperCase()
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "bot-title-meta",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "bot-name-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                children: cfg.name || "\u0411\u0415\u0417 \u0418\u041C\u0415\u041D\u0418"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "bot-age-tag",
                                                                children: [
                                                                    age,
                                                                    " \u041B\u0415\u0422"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "bot-id-tag",
                                                                children: [
                                                                    "ID: ",
                                                                    inst.id
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "bot-submeta",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "bot-geo",
                                                                children: cfg.country || "\u041B\u043E\u043A\u0430\u0446\u0438\u044F \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "bot-separator",
                                                                children: "/"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "bot-username",
                                                                children: cfg.tgProfile || "@\u043D\u0435\u0442_\u044E\u0437\u0435\u0440\u043D\u0435\u0439\u043C\u0430"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "status-badge-wrap",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: `status-badge ${inst.status}`,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "status-dot"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "status-text",
                                                    children: inst.status === 'running' ? "\u0410\u041A\u0422\u0418\u0412\u0415\u041D" : inst.status === 'error' ? "\u041E\u0428\u0418\u0411\u041A\u0410" : "\u041E\u0421\u0422\u0410\u041D\u041E\u0412\u041B\u0415\u041D"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            inst.lastError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "instance-ai-error-banner",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "ai-error-banner-top",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "ai-error-tag-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconAlert), {
                                                        size: 14,
                                                        className: "ai-error-alert-icon"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "ai-error-title",
                                                        children: "\u0421\u0411\u041E\u0419 \u0413\u0415\u041D\u0415\u0420\u0410\u0426\u0418\u0418 \u041D\u0415\u0419\u0420\u041E\u0421\u0415\u0422\u0418"
                                                    })
                                                ]
                                            }),
                                            inst.lastErrorTime && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "ai-error-time font-mono",
                                                children: new Date(inst.lastErrorTime).toLocaleTimeString('ru-RU', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit'
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "ai-error-message font-mono",
                                        children: inst.lastError
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "ai-error-resolution",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0443 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E (\u0444\u043E\u043B\u0431\u044D\u043A \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D). \u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u043A\u043B\u044E\u0447 \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                className: "ai-error-fix-btn",
                                                onClick: ()=>setEditingInstance(inst),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconEdit), {
                                                        size: 12
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043A\u043B\u044E\u0447 AI"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "instance-card-tags",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "meta-tag",
                                        title: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0445 \u0444\u043E\u0442\u043E",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconImage), {
                                                size: 12
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    photosList.length,
                                                    " \u0424\u041E\u0422\u041E"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "meta-tag preset-tag",
                                        title: "\u0421\u0442\u0438\u043B\u044C \u043E\u0431\u0449\u0435\u043D\u0438\u044F",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "meta-tag-k",
                                                children: "\u0421\u0422\u0418\u041B\u042C:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: presetLabel
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "meta-tag model-tag",
                                        title: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u0430\u044F \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u044C",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCpu), {
                                                size: 12
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: cfg.aiModel || 'gemini-2.5-flash'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: `meta-tag ${cfg.aiApiKey ? 'api-key-set' : 'api-key-unset'}`,
                                        title: cfg.aiApiKey ? "API \u041A\u043B\u044E\u0447 \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u0438 \u0437\u0430\u0434\u0430\u043D \u0432 \u0431\u043E\u0442\u0435" : "API \u041A\u043B\u044E\u0447 \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u0438 \u043D\u0435 \u0437\u0430\u0434\u0430\u043D (\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F \u043E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u044F)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "meta-tag-k",
                                                children: "API:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: cfg.aiApiKey ? "\u041A\u041B\u042E\u0427 \u0417\u0410\u0414\u0410\u041D" : "\u0418\u0417 \u041E\u041A\u0420\u0423\u0416\u0415\u041D\u0418\u042F"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "meta-tag delay-tag",
                                        title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438 \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "meta-tag-k",
                                                children: "\u0422\u0410\u0419\u041C\u0410\u0423\u0422:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    cfg.minDelay || 2,
                                                    "\u2013",
                                                    cfg.maxDelay || 15,
                                                    "\u0421"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isExpanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "expanded-details-pane",
                                children: [
                                    photosList.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "detail-photos-preview",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "detail-k",
                                                children: [
                                                    "\u0424\u041E\u0422\u041E\u0410\u041B\u042C\u0411\u041E\u041C (",
                                                    photosList.length,
                                                    "):"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mini-photos-strip",
                                                children: photosList.map((p, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: `mini-photo-thumb ${p === cfg.avatarUrl ? 'is-main' : ''}`,
                                                        title: p === cfg.avatarUrl ? "\u0413\u043B\u0430\u0432\u043D\u043E\u0435 \u0444\u043E\u0442\u043E \u043F\u0440\u043E\u0444\u0438\u043B\u044F" : `\u{424}\u{43E}\u{442}\u{43E} #${idx + 1}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: p,
                                                                alt: `Preview ${idx + 1}`,
                                                                onError: (e)=>{
                                                                    e.target.style.display = 'none';
                                                                }
                                                            }),
                                                            p === cfg.avatarUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "mini-star-mark",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconStarFilled), {
                                                                    size: 10
                                                                })
                                                            })
                                                        ]
                                                    }, idx))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "detail-grid",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "detail-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "detail-k",
                                                        children: "\u0418\u0414\u0415\u041D\u0422\u0418\u0424\u0418\u041A\u0410\u0422\u041E\u0420:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "detail-v font-mono",
                                                        children: inst.id
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "detail-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "detail-k",
                                                        children: "TELEGRAM LINK:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "detail-v font-mono",
                                                        children: cfg.tlgLink || "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "detail-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "detail-k",
                                                        children: "\u0412\u0415\u0411-\u0421\u0421\u042B\u041B\u041A\u0410:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "detail-v",
                                                        children: cfg.webLink ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: cfg.webLink,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            className: "detail-link",
                                                            children: cfg.webLink
                                                        }) : "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "detail-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "detail-k",
                                                        children: "\u041C\u0415\u0414\u0418\u0410-\u041C\u0410\u0422\u0415\u0420\u0418\u0410\u041B\u042B:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "detail-v",
                                                        children: cfg.webMedia ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: cfg.webMedia,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            className: "detail-link",
                                                            children: cfg.webMedia
                                                        }) : "\u2014"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (cfg.agentName || cfg.variables && Object.keys(cfg.variables).length > 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "detail-variables-section",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "detail-k",
                                                children: "\u041F\u0415\u0420\u0415\u041C\u0415\u041D\u041D\u042B\u0415 \u0428\u0410\u0411\u041B\u041E\u041D\u0410:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "detail-variables-badges",
                                                children: [
                                                    cfg.agentName && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "detail-var-tag",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: "agent_name:"
                                                            }),
                                                            " ",
                                                            cfg.agentName
                                                        ]
                                                    }),
                                                    cfg.variables && Object.entries(cfg.variables).map(([k, v])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "detail-var-tag",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                                    children: [
                                                                        k,
                                                                        ":"
                                                                    ]
                                                                }),
                                                                " ",
                                                                v
                                                            ]
                                                        }, k))
                                                ]
                                            })
                                        ]
                                    }),
                                    cfg.systemPrompt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "detail-prompt",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "detail-k",
                                                children: "\u0421\u0418\u0421\u0422\u0415\u041C\u041D\u042B\u0419 \u041F\u0420\u041E\u041C\u041F\u0422 (CUSTOM PROMPT):"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                                className: "prompt-pre",
                                                children: cfg.systemPrompt
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "instance-card-footer",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        className: "btn btn-expand",
                                        onClick: ()=>toggleExpand(inst.id),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: isExpanded ? "\u0421\u0412\u0415\u0420\u041D\u0423\u0422\u042C" : "\u041F\u0410\u0420\u0410\u041C\u0415\u0422\u0420\u042B"
                                            }),
                                            isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconChevronUp), {
                                                size: 12
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconChevronDown), {
                                                size: 12
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "instance-btn-group",
                                        children: [
                                            inst.status === 'running' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                className: "btn btn-warning btn-icon-only",
                                                disabled: isProcessing,
                                                onClick: ()=>handleStop(inst.id),
                                                title: isProcessing ? "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430..." : "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u043E\u0442\u0430",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconStop), {
                                                    size: 14
                                                })
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                className: "btn btn-success btn-icon-only",
                                                disabled: isProcessing,
                                                onClick: ()=>handleStart(inst.id),
                                                title: isProcessing ? "\u0417\u0430\u043F\u0443\u0441\u043A..." : "\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u0431\u043E\u0442\u0430",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconPlay), {
                                                    size: 14
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                className: `btn btn-icon-only ${inst.status === 'running' ? 'btn-secondary' : 'btn-outline'}`,
                                                onClick: ()=>setScreenshotInstance(inst),
                                                title: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u044D\u043A\u0440\u0430\u043D \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 (\u0441\u043A\u0440\u0438\u043D\u0448\u043E\u0442)",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconCamera), {
                                                    size: 15
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                className: "btn btn-outline btn-icon-only",
                                                onClick: ()=>setEditingInstance(inst),
                                                title: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0431\u043E\u0442\u0430",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconEdit), {
                                                    size: 14
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                className: "btn btn-danger btn-icon-only",
                                                onClick: ()=>handleDelete(inst.id, cfg.name || inst.id),
                                                title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0431\u043E\u0442\u0430",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconTrash), {
                                                    size: 14
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, inst.id);
                })
            }),
            showCreateForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56aae118d8454be8$export$6360ef58bf398c93), {
                onSubmit: handleCreateInstance,
                onCancel: ()=>setShowCreateForm(false)
            }),
            editingInstance && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a22557d8003a0749$export$3c330c36ee2ee261), {
                instance: editingInstance,
                onSubmit: handleUpdate,
                onCancel: ()=>setEditingInstance(null)
            }),
            screenshotInstance && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6de12348ffb204f$export$9aed520f056d3641), {
                instanceId: screenshotInstance.id,
                instanceName: screenshotInstance.config?.name || screenshotInstance.id,
                isRunning: screenshotInstance.status === 'running',
                onClose: ()=>setScreenshotInstance(null)
            })
        ]
    });
};



var $d5yWr = parcelRequire("d5yWr");

var $cxNgw = parcelRequire("cxNgw");

var $aZAsu = parcelRequire("aZAsu");
const $2bc82ae496ef9d14$export$c67a8869b938d43b = ()=>{
    const [isAuthenticated, setIsAuthenticated] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const token = (0, $cxNgw.authService).getAuthToken();
        if (token) setIsAuthenticated(true);
    }, []);
    const handleAuth = async (key)=>{
        try {
            const response = await fetch('/api/auth/verify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: key
                })
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438");
            }
            const { token: token } = await response.json();
            (0, $cxNgw.authService).setAuthToken(token);
            setIsAuthenticated(true);
            setError(null);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "\u041E\u0448\u0438\u0431\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438";
            setError(errorMessage);
        }
    };
    const handleLogout = ()=>{
        (0, $cxNgw.authService).removeAuthToken();
        setIsAuthenticated(false);
    };
    if (!isAuthenticated) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5yWr.Auth), {
        onAuth: handleAuth
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "admin-shell",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "admin-navbar",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "navbar-brand",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "brand-logo-mark",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconTerminal), {
                                    size: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "brand-title-row",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                className: "brand-title",
                                                children: "MIMIC AI"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "brand-badge-tag",
                                                children: "ENTERPRISE"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "brand-sub",
                                        children: "\u0410\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u0430\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F AI-\u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043C\u0438"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "navbar-user-actions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "admin-status-indicator",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "indicator-live-dot"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "\u0421\u0418\u0421\u0422\u0415\u041C\u0410 \u0410\u041A\u0422\u0418\u0412\u041D\u0410"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                onClick: handleLogout,
                                className: "btn btn-logout",
                                title: "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u0441\u0438\u0441\u0442\u0435\u043C\u044B",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZAsu.IconLogout), {
                                        size: 14
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "\u0412\u044B\u0439\u0442\u0438"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                className: "admin-main-content",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebab744a88129edc$export$2e18f541b3e93e), {})
            })
        ]
    });
};



var $cxNgw = parcelRequire("cxNgw");

// Проверяем авторизацию при загрузке
if (!(0, $cxNgw.authService).isAuthenticated() && window.location.pathname !== '/login') window.location.href = '/login';
const $22edf7306316b675$var$container = document.getElementById('root');
if ($22edf7306316b675$var$container) {
    const root = (0, $aRPiL.createRoot)($22edf7306316b675$var$container);
    root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2bc82ae496ef9d14$export$c67a8869b938d43b), {}));
}


//# sourceMappingURL=admin.4edecf3c.js.map
